<template>
  <div class="page-table-layout" data-testid="tasklist">
    <v-card :loading="loading" class="all-width flex-card shadow-off" :disabled="loading" loader-height="2" data-testid="tasklist__main-card">
      <v-card-text class="page-table-layout__body" data-testid="tasklist__main-card-text">
  <div class="d-flex align-center justify-space-between" data-testid="tasklist__toolbar">
          <div class="d-flex align-center" data-testid="tasklist__toolbar-title-panel">
            <h3 class="ma-0 font-weight-medium" data-testid="tasklist__title">Tasklist</h3>
            <v-tooltip bottom content-class="tooltip-bottom" data-testid="tasklist__refresh-tooltip">
              <template v-slot:activator="{ on, attrs }"> 
                  <v-btn data-testid="tasklist__refresh-btn"
                      v-bind="attrs"
                      v-on="on"
                      class="shadow-off ml-1" icon @click="refreshData()"><v-icon
                      size="24" data-testid="tasklist__refresh-btn-icon">mdi-refresh</v-icon>
                  </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
            <activity-log 
              :resource-id="clientID"
              data-testid="financialclose-project-users__activitylog"
              row-description="Tasklist" 
              :type="$options.ACTIVITY_LOG_TYPES.MASTER_TASKLIST"
              />
          </div>
          <div class="d-flex align-center ma-0" data-testid="tasklist__toolbar-actions-panel">
            <lb-dropdown
              data-testid="tasklist__cycle-type-dropdown"
              label="Select Cycle type"
              v-model="cycleType"
              :items="cycleTypes"
              itemtext="displayText"
              itemvalue="name"
              hidedetails
              class="mr-2"
              v-if="$nova.hasRight(right, 'add')" 
              item-class="noTransform"
            />
            <bulkChecklistUploadV2
              uploadType="checklist"
              data-testid="tasklist__bulk-upload"
              :expectedHeadings="expectedHeaders" 
              :customColumns="customColumns"
              :chartOfAccounts="chartAcc" 
              :activeUsers = "userDetails.activeUsers"
              :cycle_type="cycleType"
              @reload="refreshData()" 
              v-if="$nova.hasRight(right, 'add')"
            />
            <v-btn 
              data-testid="tasklist__new-task-btn"
              color="primary" 
              class="mr-2 px-4" 
              @click="handleNewTask" 
              v-if="$nova.hasRight(right, 'add')"
            >
              <v-icon class="pr-2" data-testid="tasklist__new-task-btn-icon">mdi-plus</v-icon>
              <span class="" data-testid="tasklist__new-task-btn-label">New Task</span>
            </v-btn>
          </div>
        </div>
  <div class="d-flex align-center justify-space-between my-3 " data-testid="tasklist__sub-toolbar">
          <!-- /* TODO: Temporarily set to display: none; for current requirements. Will be updated in future versions. */ -->
          <div class="d-none"> 
          <lb-string placeholder="Search" label="" v-model="search" width="30vh" appendiconinner="mdi-magnify"
            hidedetails radius="8px" :isClearable="false" />
          <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ma-2" text icon color="lighten-2" v-bind="attrs" v-on="on" data-testid="tasklist__search-info-btn">
                <v-icon>mdi-information</v-icon>
              </v-btn>
            </template>
            <span>Search for the description </span>
          </v-tooltip>
          </div>
            <v-btn v-if="formatedDataCopy.length > 0" color="primary" class="mr-1 px-4"
              data-testid="tasklist__add-column-btn"
              @click="showNewColumnModal = true; columnDetails = {
                cycleType: cycleType, 
                displayName: '',
                dataType: ''
              }; columnDetailsError={}">
              <span class=""> <v-icon class="pr-2" data-testid="tasklist__add-column-btn-icon">mdi-plus</v-icon><span data-testid="tasklist__add-column-btn-label">Add New Column</span></span>
            </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <div class="" data-testid="tasklist__actions-panel">
            <v-menu v-if="selectItem.length > 0" :close-on-content-click="false" offset-y
              transition="slide-y-transition" data-testid="tasklist__bulk-actions-menu">
              <template v-slot:activator="{ on, attrs }">
                <v-tooltip left content-class="tooltip-left" data-testid="tasklist__bulk-actions-tooltip">
                  <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn icon v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }"  class="ml-2" data-testid="tasklist__bulk-actions-btn"><v-icon data-testid="tasklist__bulk-actions-btn-icon">mdi-dots-horizontal</v-icon></v-btn>
                  </template>
                  <span>Bulk actions</span>
                </v-tooltip>
              </template>

              <v-list style="max-height:70vh ;min-width:50vh; max-width: 90vh; overflow:hidden; z-index:2"
                class="pa-0 ma-0 flex-column align-start justify-start mr-0" data-testid="tasklist__bulk-actions-list">
                <div class="ma-0  all-width" data-testid="tasklist__bulk-actions-list-title">
                  <div class="d-flex tableHeaderBg align-center  pa-3 justify-space-between">
                    <p class="ma-0 font-weight-bold" v-if="bulkActionStage === 0">Bulk Actions</p>
                    <v-icon color="primary" class="px-2">mdi-information-outline</v-icon>
                  </div>
                  <v-divider></v-divider>
                </div>
                <v-list-item class="cursor-pointer hoverable-caccounting all-width  radius-small" @click="bulkActionDuedilog(selectItem)" data-testid="tasklist__bulk-actions-edit-due-days">
                  <v-icon class="pr-2" data-testid="tasklist__bulk-actions-edit-due-days-icon">mdi-calendar-today-outline</v-icon>
                  <span data-testid="tasklist__bulk-actions-edit-due-days-label">Edit Due Days</span>
              </v-list-item>

          <v-list-item class="cursor-pointer hoverable-caccounting all-width  radius-small" v-if="bulkActionStage === 0" @click="bulkActionStage++" data-testid="tasklist__bulk-actions-location-users">
            <v-icon class="pr-2" data-testid="tasklist__bulk-actions-location-users-icon">mdi-map-marker-radius-outline</v-icon>
            <span data-testid="tasklist__bulk-actions-location-users-label"> {{$store.state.LocationHeader|| 'Location' }}, Users & Threshold Enforcement</span>
          </v-list-item>

          <v-list-item class="cursor-pointer hoverable-caccounting all-width  radius-small"  @click="bulkEditTask(selectItem)" data-testid="tasklist__bulk-actions-bulk-edit-tasks">
            <v-icon class="pr-2" data-testid="tasklist__bulk-actions-bulk-edit-tasks-icon">mdi-text-box-edit</v-icon>
            <span data-testid="tasklist__bulk-actions-bulk-edit-tasks-label">Bulk Edit Tasks </span>
          </v-list-item>

                     <div class="d-flex">
                      <v-icon v-if="bulkActionStage > 0" @click="bulkActionStage--" color="primary"
                        class="px-2" data-testid="tasklist__bulk-actions-backstage-btn">mdi-keyboard-backspace</v-icon>
                      <p class="ma-0 font-weight-bold" v-if="bulkActionStage === 1">Choose {{$store.state.LocationHeader|| 'Location'}}</p>
                      <p class="ma-0 font-weight-bold" v-if="bulkActionStage === 2">Select Preparer</p>
                      <p class="ma-0 font-weight-bold" v-if="bulkActionStage === 3">Select Approver</p>
                      <p class="ma-0 font-weight-bold" v-if="bulkActionStage === 4 && bulkSelectionHasReconTasks">Select Threshold Enforcement</p>
                    </div>
                <span v-if="bulkActionStage === 0" class="pa-2 ma-2 cursor-pointer d-none" @click="bulkActionStage++" >
                  {{$store.state.LocationHeader|| 'Location' }}
                  &
                  Users</span>
                <v-list-item v-else class="all-width d-flex px-1 flex-column" style="max-height:25vh; overflow:scroll">
                  <div class="ma-0 pa-0 my-1 all-width" v-if="bulkActionStage === 1">
                    <lb-string label="" placeholder="Search" v-model="searchlocation" :hidedetails="true"
                      appendinnericon="mdi-magnify" class="px-2 mt-1 all-width" />
                    <v-checkbox v-for="(item, index) in filteredlocation" :key="index" v-model="addLocation"
                      :value="item._id" @change="loactioncheck(addLocation,item._id)" color="caccounting" class="ma-0 pa-0 py-1" hide-details
                      :label="item.name"></v-checkbox>
                  </div>

                  <div class="ma-0 pa-0 my-1 all-width" v-else-if="bulkActionStage === 2">
                    <lb-string label="" placeholder="Search" v-model="searchusername" :hidedetails="true"
                      appendinnericon="mdi-magnify" class="px-2 mt-1 all-width" />
                      <div class="d-flex flex-wrap align-start flex-direction-column">
                        <template v-for="(item, index) in filteredActiveUsers">
                          <v-checkbox
                            :label="item.name"
                            :key="index"
                            class="pa-2 ma-1"
                            :input-value="addPrepares.includes(item._id)"
                            @change="togglePreparer(item._id)"
                            color="caccounting"
                            hide-details
                          >
                           <template v-slot:label>
                            <span :class="{ 'inactive-user-label': item?.inactive }">{{ item.name }}</span>
                          </template>
                        </v-checkbox>
                        </template>
                      </div>
                  </div>
                  <div class="ma-0 pa-0 my-1 all-width" v-else-if="bulkActionStage === 3">
                    <lb-string label="" placeholder="Search" v-model="searchusername" :hidedetails="true"
                      appendinnericon="mdi-magnify" class="px-2 mt-1 all-width" />
                       <div class="d-flex flex-wrap align-start flex-direction-column">
                        <template v-for="(item, index) in filteredActiveUsers">
                          <v-checkbox
                            :label="item.name"
                            :key="index"
                            class="pa-2 ma-1"
                            :input-value="addApprover.includes(item._id)"
                            @change="toggleApprover(item._id)"
                            color="caccounting"
                            hide-details
                          >
                          <template v-slot:label>
                            <span :class="{ 'inactive-user-label': item?.inactive }">{{ item.name }}</span>
                          </template>
                        </v-checkbox>
                        </template>
                      </div>
                  </div>
                  <div class="ma-0 pa-0 my-1 all-width" v-else-if="bulkActionStage === 4 && bulkSelectionHasReconTasks">
                    <v-row no-gutters class="pa-2 row-gap-2 gap-2">
                      <v-col cols="12">
                        <v-card outlined :class="['enable-disable-radio-card pa-3', bulkManageSkipValidation === true ? 'enable-disable-radio-card--selected' : '']"
                          @click="bulkManageSkipValidation = true">
                          <div class="d-flex align-center">
                            <v-icon class="mr-2 flex-shrink-0" :color="bulkManageSkipValidation === true ? 'primary' : 'grey lighten-1'">
                              {{ bulkManageSkipValidation === true ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                            </v-icon>
                            <div>
                              <p class="font-weight-medium mb-0 text-body-2">Enable Threshold Enforcement</p>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12">
                        <v-card outlined :class="['enable-disable-radio-card pa-3', bulkManageSkipValidation === false ? 'enable-disable-radio-card--selected' : '']"
                          @click="bulkManageSkipValidation = false">
                          <div class="d-flex align-center">
                            <v-icon class="mr-2 flex-shrink-0" :color="bulkManageSkipValidation === false ? 'primary' : 'grey lighten-1'">
                              {{ bulkManageSkipValidation === false ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                            </v-icon>
                            <div>
                              <p class="font-weight-medium mb-0 text-body-2">Disable Threshold Enforcement</p>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-list-item>

                <div v-if="bulkActionStage !== 0" class="d-flex all-width pa-1 align-center justify-space-between">
                  <v-btn v-if="bulkActionStage === 1 " color="primary" class="white--text mr-1 d-flex" @click="addnewLocation=true; locationdata=[]" data-testid="tasklist__bulk-actions-add-location-btn"><span> Add {{this.$store.state.LocationHeader|| 'Location'}}</span></v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="white--text ml-1 mr-0 d-flex" @click="nextStage()"
                    v-if="bulkActionStage === 1" data-testid="tasklist__bulk-actions-next-btn" :disabled=" !(addLocation.length > 0)">Next</v-btn>
                    <v-btn color="primary" class="white--text ml-1 mr-0 d-flex" @click="nextStage()"
                    v-if="bulkActionStage === 2" data-testid="tasklist__bulk-actions-next-btn" :disabled="!(addPrepares.length > 0)">Next</v-btn>
                  <v-btn color="primary" class="white--text ml-1 mr-0 d-flex" @click="nextStage()"
                    v-if="bulkActionStage === 3" data-testid="tasklist__bulk-actions-next-btn" :disabled="!(addApprover.length > 0)">Next</v-btn>
                  <v-btn color="primary" class="white--text" @click="submitChanges()" v-else-if="bulkActionStage === 4 && bulkSelectionHasReconTasks" data-testid="tasklist__bulk-actions-submit-btn"><span>Submit</span></v-btn>
                </div>
              </v-list>
            </v-menu>

            <!-- Clear Filter Button -->
            <v-btn
              v-if="hasActiveTableFilter"
              outlined
              small
              class="mr-2"
              color="caccounting"
              @click="clearTableFilter()"
              data-testid="tasklist__toolbar-clear-filter-btn"
            >
              <v-icon left data-testid="tasklist__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
              <span>Clear Filter</span>
            </v-btn>
            <v-tooltip bottom content-class="tooltip-bottom" data-testid="tasklist__download-excel-tooltip">
              <template v-slot:activator="{ on }">
                <v-btn class="shadow-off mr-2" v-on="on" text @click="exportToCsv()" icon data-testid="tasklist__download-excel-btn"><v-icon data-testid="tasklist__download-excel-btn-icon">mdi-file-excel-outline</v-icon></v-btn>
              </template>
              <span>Download Excel</span>
            </v-tooltip>
            <!-- CustomizeColumnMenu component - Apply and Save -->
            <CustomizeColumnMenu
              v-model="customizeMenuOpen"
              :headers="headers"
              :page-name="page_name"
              :loading="loading"
              color="caccounting"
              :show-save-button="true"
              :show-apply-button="true"
              data-testid-prefix="tasklist"
              @apply="handleApplyColumns"
              @save="handleSaveColumns"
            />

          </div>

        </div>

  <div class="d-flex" data-testid="tasklist__active-filters-panel">
          <div v-for="(filter, index) in selectedFilterItems" :key="index" class="d-flex">
            <div v-for="(values, key) in filter" :key="key" class="d-flex">
              <div v-for="(value, i) in values" :key="i"
                class="d-flex border-on pa-1 radius-medium caccounting--text caccounting-background mx-2 mb-2">
                <p class="ma-0 pa-0 pr-1 ">{{ key }} - </p>
                <p class="ma-0 pa-0">{{ value }}</p>
              </div>
            </div>
          </div>
          <v-btn v-if="selectedFilterItems.length > 0" text class="font-weight-bold font-size-xm"
            @click="resetStage" data-testid="tasklist__reset-filter-btn"><span>Reset
            filter</span>
          </v-btn>
        </div>
        <div v-if="!loading" class="all-width flex-fill-table" data-testid="tasklist__table-panel">
          <lb-datatableaction 
            ref="dataTableAction"
            data-testid="tasklist__table"
            :headers="headers"
            :tabledata="formatedDataCopy"
            :displayedRowCount="paginatedFilteredItems.length"
            :itemsperpage="itemsPerPage"
            :searchterm="search" 
            :selectfilter="tableFilterHeader"
            :isDataSelected="selectItem.length > 0 && selectItem.length < filteredItemsfromsearch.length ? true : false" 
            :page_details="page_details"
            :enableSaveOption="true"
            @select-all-change="select" 
            @filter-item="filterPart" 
            @filter-active-change="onFilterActiveChange"
            @refresh="getRefresh" 
            @sort-order="sortingOrder"
            @column-reorder="onColumnReorder">
            <template v-slot:tbody="{ headers: tableHeaders }">
              <tr v-for="item in paginatedFilteredItems" :key="item._id" class="cursor-pointer "
                :class="{ 'low-opacity': item.status === false, '': viewchecklistdata === item }" data-testid="tasklist__row">
                <td class="d-flex align-center justify-center" data-testid="tasklist__row-checkbox-cell">
                    <v-checkbox dense
                      data-testid="tasklist__row-checkbox"
                      color="caccounting"
                      class="ma-0 py-1 single-line"
                      :ripple="false"
                      hide-details
                      :value="item"
                      multiple
                      v-model="selectItem"></v-checkbox>
                </td>
                <template v-for="header in tableHeaders">
                  <td v-if="header.visible" :key="header.value"
                    :class="{ 'description-header': header.value === 'description', 'single-line': header.value !== 'description' }"
                    :data-testid="`tasklist__cell-${header.value}`">
                    <span v-if="header.value === 'description'" @click="viewChecklist(item)" class="line-clamp-2" data-testid="tasklist__cell-description">{{
                      getItemData(item, header.value) }}</span>
                    <div v-else-if="header.value === 'assertionscount'" data-testid="tasklist__cell-assertionscount">
                      <span class="pr-2" data-testid="tasklist__cell-assertionscount-main">{{ item.assertions[0] }}</span>
                      <v-tooltip top content-class="tooltip-top" data-testid="tasklist__cell-assertionscount-tooltip">
                        <template v-slot:activator="{ on }">
                          <span v-on="on" v-if="item.assertions.length > 1"
                            class="border-on radius-mini font-size-xm purple--text pa-1 " data-testid="tasklist__cell-assertionscount-more">+{{ item.assertions.length - 1 }}</span>
                        </template>
                        <div v-for="(item, index) in item.assertions" :key="index" :data-testid="`tasklist__cell-assertionscount-tooltip-item-${index}`">
                          <span>{{item}}</span>
                        </div>
                      </v-tooltip>
                    </div>
                    <div v-else-if="header.value === 'location'" data-testid="tasklist__cell-location">
                      <span v-if="hasLocation(item)"
                        class="caccounting--text caccounting-background pa-1 mr-2 radius-mini" data-testid="tasklist__cell-location-main">{{ item.location[0] }}</span>
                      <v-tooltip top content-class="tooltip-top" v-if="hasLocation(item)" data-testid="tasklist__cell-location-tooltip">
                        <template v-slot:activator="{ on }">
                          <span v-on="on"
                            v-if="hasLocation(item) && item.location.length > 1"
                            class="border-on radius-mini font-size-xm purple--text pa-1" data-testid="tasklist__cell-location-more">
                            +{{ item.location.length - 1 }}
                          </span>
                        </template>
                        <div v-if="hasLocation(item) && item.location.length > 1">
                          <div v-for="loc in additionalLocations(item)" :key="loc" :data-testid="`tasklist__cell-location-tooltip-item-${loc}`">
                            <span>{{ loc }}</span>
                          </div>
                        </div>
                      </v-tooltip>
                    </div>
                    <div v-else-if="header.value === 'tags'" data-testid="tasklist__cell-tags">
                      <span class="pr-2" data-testid="tasklist__cell-tags-main">{{ item.tags[0] }}</span>
                      <v-tooltip top content-class="tooltip-top" data-testid="tasklist__cell-tags-tooltip">
                        <template v-slot:activator="{ on }">
                          <span v-if="item.tags.length > 1" v-on="on" class="border-on radius-mini font-size-xm purple--text pa-1 " data-testid="tasklist__cell-tags-more">+{{
                            item.tags.length - 1
                            }}</span>
                        </template>
                        <div v-for="(item, index) in item.tags" :key="index" :data-testid="`tasklist__cell-tags-tooltip-item-${index}`">
                          <span>{{item}}</span>
                        </div>
                      </v-tooltip>
                    </div>
                    <div class="" v-else-if="header.value === 'preparer'" data-testid="tasklist__cell-preparer">
                      <div class="d-flex px-1">
                          <div v-for="(preparer, index) in item?.preparer.slice(0, 4)" :key="index" class="avatars-group__item d-flex" :data-testid="`tasklist__cell-preparer-avatar-${index}`">
                              <v-tooltip top content-class="tooltip-top" v-if="preparer" :data-testid="`tasklist__cell-preparer-tooltip-${index}`">
                                  <template v-slot:activator="{ on }">
                                      <v-avatar v-on="on" size="25" color="avatar-bg" class="white--text font-small d-flex pa-0 ma-0 noTransform" :data-testid="`tasklist__cell-preparer-avatar-initial-${index}`">
                                          {{ preparer?.charAt(0).toUpperCase() }}
                                      </v-avatar>
                                  </template>
                                  <span>{{ preparer }}</span>
                              </v-tooltip>
                          </div>
                          <v-tooltip top content-class="tooltip-top" v-if="item?.preparer?.length > 4" data-testid="tasklist__cell-preparer-tooltip-more">
                              <template v-slot:activator="{ on }">
                                  <v-avatar v-on="on" size="25" color="lime lighten-1" style="margin-left:-8px !important" class="white--text align-center justify-center d-flex pa-0 avatar-white-border ma-0 v-avatar" data-testid="tasklist__cell-preparer-avatar-more">
                                      <v-icon color="white">mdi-plus</v-icon>
                                  </v-avatar>
                              </template>
                              <div class="" v-for="(preparer, index) in item?.preparer" :key="index" :data-testid="`tasklist__cell-preparer-tooltip-more-item-${index}`">
                                  <span>{{ preparer }}</span>
                              </div>
                          </v-tooltip>
                      </div>
                  </div>
                  <div class="" v-else-if="header.value === 'approver'" data-testid="tasklist__cell-approver">
                      <div class="d-flex px-1">
                          <div v-for="(approver, index) in item?.approver.slice(0, 4)" :key="index" class="avatars-group__item d-flex" :data-testid="`tasklist__cell-approver-avatar-${index}`">
                              <v-tooltip top content-class="tooltip-top" v-if="approver" :data-testid="`tasklist__cell-approver-tooltip-${index}`">
                                  <template v-slot:activator="{ on }">
                                      <v-avatar v-on="on" size="25" color="avatar-bg" class="white--text font-small d-flex pa-0 ma-0 noTransform" :data-testid="`tasklist__cell-approver-avatar-initial-${index}`">
                                          {{ approver?.charAt(0).toUpperCase() }}
                                      </v-avatar>
                                  </template>
                                  <span>{{ approver }}</span>
                              </v-tooltip>
                          </div>
                          <v-tooltip top content-class="tooltip-top" v-if="item?.approver?.length > 4" data-testid="tasklist__cell-approver-tooltip-more">
                              <template v-slot:activator="{ on }">
                                  <v-avatar v-on="on" size="25" color="green lighten-2" style="margin-left:-8px !important" class="white--text align-center justify-center d-flex pa-0 avatar-white-border ma-0 v-avatar" data-testid="tasklist__cell-approver-avatar-more">
                                      <v-icon color="white">mdi-plus</v-icon>
                                  </v-avatar>
                              </template>
                              <div class="" v-for="(approver, index) in item?.approver" :key="index" :data-testid="`tasklist__cell-approver-tooltip-more-item-${index}`">
                                  <span>{{ approver }}</span>
                              </div>
                          </v-tooltip>
                      </div>
                  </div>
                    <div class="" v-else-if="header.value === 'action'" data-testid="tasklist__cell-action">
                  <!-- <v-tooltip left content-class="tooltip-left" data-testid="tasklist__cell-action-edit-tooltip">
                    <template v-slot:activator="{ on }">
                      <v-btn icon @click="addEditForm(item)" v-on="on" :disabled="!item.status" data-testid="tasklist__cell-action-edit-btn"><v-icon data-testid="tasklist__cell-action-edit-btn-icon">mdi-pencil-outline</v-icon></v-btn>
                    </template>
                    Edit
                  </v-tooltip> -->


                  <div class="action-icons d-flex align-center gap-2">
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/Pencil-Inventory-Icon.svg"
                              image-alt="Edit Icon"
                              v-bind="attrs"
                              v-on="on"
                              data-testid="tasklist__row-action-edit-btn"
                              @click="addEditForm(item)"
                            />
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                         
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="!item.status">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/fbc-icons/Close-Inventory-Icon.svg"
                              image-alt="Approvals Icon"
                              v-bind="attrs"
                              v-on="on"
                              data-testid="tasklist__row-action-enable-btn"
                               @click.stop="enableDisableAccess(item._id, 'enable')"
                            />
                          </template>
                          <span>Disabled</span>
                        </v-tooltip>
                         <v-tooltip bottom content-class="tooltip-bottom" v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/ApproveGreenIcon.svg"
                              image-alt="Approvals Icon"
                              v-bind="attrs"
                              v-on="on"
                              data-testid="tasklist__row-action-disable-btn"
                              @click="enableDisableAccess(item._id, 'disable')"
                            />
                          </template>
                          <span>Enabled</span>
                        </v-tooltip>
                        <activity-log
                        :resource-id="item._id"
                        :row-description="item.description"
                      />
                      </div>



                  <!-- <v-menu :close-on-content-click="false" offset-y transition="slide-y-transition" bottom data-testid="tasklist__cell-action-menu">
                    <template v-slot:activator="{ on, attrs }">
                      <v-tooltip bottom content-class="tooltip-bottom" data-testid="tasklist__cell-action-menu-tooltip">
                        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                        <v-btn icon v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }"  class="ml-2" data-testid="tasklist__cell-action-menu-btn"><v-icon data-testid="tasklist__cell-action-menu-btn-icon">mdi-dots-horizontal</v-icon></v-btn>
                        </template>
                        <span>Action</span>
                      </v-tooltip>
                    </template>
                    <v-list class="pa-0 ma-0" data-testid="tasklist__cell-action-menu-list">
                      <v-menu :close-on-content-click="false" offset-x class="activitymenu"
                        transition="slide-x-transition" left style="min-width: fit-content !important" data-testid="tasklist__cell-action-activity-menu">
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item class="pa-0 ma-0 px-3" v-bind="attrs" v-on="on" @click="activityLogById=[],ActivityLogData(item._id)" data-testid="tasklist__cell-action-activity-menu-item">
                            <v-icon data-testid="tasklist__cell-action-activity-menu-item-icon">mdi-history</v-icon>
                            <p class="pa-0 ma-0 px-2" data-testid="tasklist__cell-action-activity-menu-item-label">Activity Log</p>
                          </v-list-item>
                        </template>
                        <v-list class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                          style="max-height:50vh; overflow:hidden; min-width:40vh; max-width:40vh" data-testid="tasklist__cell-action-activity-menu-list">
                          <v-list-tilte
                            class="d-flex align-center mb-2 tableHeaderBg black--text pa-2 justify-start all-width" data-testid="tasklist__cell-action-activity-menu-list-title">
                            <p class="pa-0 ma-0">Activity Log</p>
                          </v-list-tilte>
                          <v-list-item v-if="activitylogLoading" data-testid="tasklist__cell-action-activity-menu-list-loading">
                            Loading...
                          </v-list-item>
                          <v-list-item v-else class="d-flex flex-column all-width align-start justify-start"
                            style="overflow:scroll" data-testid="tasklist__cell-action-activity-menu-list-items">
                            <div class="d-flex flex-column align-start justify-start all-width"
                              v-for="(v, k) in activityLogById" :key="k" :data-testid="`tasklist__cell-action-activity-menu-list-log-${k}`">
                              <span class="font-size-xm py-1"
                                v-if="k === 0 || v.created_at.split('T')[0] !== activityLogById[k - 1].created_at.split('T')[0]">
                                {{ $nova.formatDateTime(new Date(v.created_at), "DD MMM yyyy") }}
                                {{ v.created_at.split("T")[0] }}
                              </span>
                              <v-timeline class="pa-0 ma-0 all-width">
                                <v-timeline-item class="d-flex align-start justify-start all-width">
                                  <template v-slot:icon>
                                    <v-avatar size="6" color="gray" class="custom-avatar  "></v-avatar>
                                  </template>
                                  <template v-slot:opposite>
                                    <span class="font-size-xm align-start d-flex ">
                                      {{ $nova.formatDateTime(new Date(v.created_at), "hh:mm A") }}
                                    </span>
                                  </template>
                                  <div class="d-flex flex-column align-start d-flex">
                                    <span class="font-size-xm">
                                      {{ v.text || (activitylogconfig[v.type] || {}).displaytext || v.type }}
                                    </span>
                                    <div class="d-flex align-center mr-10 justify-center">
                                      <v-avatar class="mr-2" size="20">{{ (v.userid_detail || 
                                        {}).name[0] }}</v-avatar>
                                      <span>{{ (v.userid_detail || {}).name }}</span>
                                    </div>
                                  </div>
                                </v-timeline-item>
                              </v-timeline>
                            </div>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-list-item @click="enableDisableAccess(item._id, 'disable')" v-if="item.status"
                        class="pa-0 ma-0 px-3" data-testid="tasklist__cell-action-disable-btn-item">
                        <v-icon color="error" data-testid="tasklist__cell-action-disable-btn-icon">mdi-close-circle</v-icon>
                        <p class="error--text pa-0 ma-0 px-2" data-testid="tasklist__cell-action-disable-btn-label">Disable</p>
                      </v-list-item>
                      <v-list-item @click.stop="enableDisableAccess(item._id, 'enable')" v-else class="pa-0 ma-0 px-3" data-testid="tasklist__cell-action-enable-btn-item">
                        <v-icon color="success" data-testid="tasklist__cell-action-enable-btn-icon">mdi-check-circle</v-icon>
                        <p class="success--text pa-0 ma-0 px-2" data-testid="tasklist__cell-action-enable-btn-label">Enable</p>
                      </v-list-item>
                    </v-list>
                  </v-menu> -->
                </div>
                <span class="line-clamp-2" v-else data-testid="tasklist__cell-generic">{{ getItemData(item, header.value) }}</span>
                </td>
                </template>
              </tr>
            </template>
          </lb-datatableaction>
        </div>
  <div v-else data-testid="tasklist__empty-state-panel">
          <v-stepper v-if="!loading" v-model="e13" vertical data-testid="tasklist__empty-stepper">
            <v-stepper-items data-testid="tasklist__empty-stepper-items">
              <v-stepper-step step="1" editable data-testid="tasklist__empty-stepper-step-1">Add Column</v-stepper-step>
              <v-stepper-content  step="1" data-testid="tasklist__empty-stepper-content-1">
          <v-card class="mt-2 mb-2 elevation-2" color="#fafafa " data-testid="tasklist__empty-stepper-card-1">
            <v-card-title data-testid="tasklist__empty-stepper-card-1-title">
            <h3 data-testid="tasklist__empty-stepper-card-1-title-label">Existing Columns</h3>
            </v-card-title>
            <v-card-text data-testid="tasklist__empty-stepper-card-1-text">
            <v-row data-testid="tasklist__empty-stepper-card-1-row">
              <v-chip-group column class="pa-2 ma-2" data-testid="tasklist__empty-stepper-card-1-chip-group">
              <v-chip v-for="(header, index) in headers" :key="index" outlined class="ma-1 d-flex align-center " :data-testid="`tasklist__empty-stepper-card-1-chip-${index}`">
                <template v-if="header.isEditing">
            <v-text-field 
              v-model="header.value" 
              dense 
              class="ma-0 pa-0 mt-4" 
              @blur="saveHeaderText(header)" 
              @keyup.enter="saveHeaderText(header)" 
              data-testid="tasklist__empty-stepper-card-1-chip-edit-field"
            />
                </template>
                <template v-else>
            <span class="mr-2" data-testid="tasklist__empty-stepper-card-1-chip-label">{{ header.value }}</span>
                </template>
                <div class="d-flex ml-auto">
            <template v-if="header && header.custom">
              <v-btn icon small @click="toggleEditHeader(header)" data-testid="tasklist__empty-stepper-card-1-chip-edit-btn">
                <v-icon data-testid="tasklist__empty-stepper-card-1-chip-edit-btn-icon">{{ header.isEditing ? 'mdi-check' : 'mdi-pencil' }}</v-icon>
              </v-btn>
              <v-btn icon small @click="deleteCustomColumn(header)" data-testid="tasklist__empty-stepper-card-1-chip-delete-btn">
                <v-icon color="error" data-testid="tasklist__empty-stepper-card-1-chip-delete-btn-icon">mdi-delete</v-icon>
              </v-btn>
            </template>
                </div>
              </v-chip>
              </v-chip-group>
            </v-row>
        <v-btn color="primary" class="mr-1 px-4 mb-2"
           @click="showNewColumnModal = true; columnDetails = {
              cycleType: cycleType, 
              displayName: '',
              dataType: ''
            };columnDetailsError={}" data-testid="tasklist__empty-stepper-card-1-add-column-btn">
            <span class=""> <v-icon class="pr-2" data-testid="tasklist__empty-stepper-card-1-add-column-btn-icon">mdi-plus</v-icon> <span data-testid="tasklist__empty-stepper-card-1-add-column-btn-label">Add New Column</span></span>
          </v-btn>
            </v-card-text>
          </v-card>
          <v-btn color="primary" @click="e13 = 2" data-testid="tasklist__empty-stepper-card-1-next-btn"><span>Next</span></v-btn>
              </v-stepper-content>

              <v-stepper-step step="2" editable data-testid="tasklist__empty-stepper-step-2">Bulk Upload Template</v-stepper-step>
          <v-stepper-content step="2" data-testid="tasklist__empty-stepper-content-2">
          <v-card class="mt-2 mb-4 elevation-2" color="#fafafa" data-testid="tasklist__empty-stepper-card-2">
            <v-card-title data-testid="tasklist__empty-stepper-card-2-title">
            <h3 data-testid="tasklist__empty-stepper-card-2-title-label">Bulk Upload Template</h3>
            </v-card-title>
            <v-card-text data-testid="tasklist__empty-stepper-card-2-text">
            <p data-testid="tasklist__empty-stepper-card-2-desc">Upload your bulk template here...</p>
            <bulkChecklistUploadV2 :cycle_type="cycleType"  :customColumns="customColumns" @reload="refreshData()" v-if="$nova.hasRight(right, 'add')" data-testid="tasklist__empty-stepper-card-2-bulk-upload" />
              <div class="d-flex align-center py-2" style="width: 12%" data-testid="tasklist__empty-stepper-card-2-or-panel">
              <v-divider class="mx-2" data-testid="tasklist__empty-stepper-card-2-or-divider-1"></v-divider>
              <span class="mx-2" data-testid="tasklist__empty-stepper-card-2-or-label">or</span>
              <v-divider class="mx-2" data-testid="tasklist__empty-stepper-card-2-or-divider-2"></v-divider>
            </div>
            <v-btn 
               color="primary" 
               class="mr-2 px-4" 
               @click="handleNewTask" 
               v-if="$nova.hasRight(right, 'add')"
               data-testid="tasklist__empty-stepper-card-2-new-task-btn">
              <v-icon class="pr-2" data-testid="tasklist__empty-stepper-card-2-new-task-btn-icon">mdi-plus</v-icon>
              <span class="" data-testid="tasklist__empty-stepper-card-2-new-task-btn-label">New Task</span>
            </v-btn>
            </v-card-text>
          </v-card>
          </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
        
      </v-card-text>
    </v-card>

    <lb-drawer v-model="viewchecklistdialog" heading="Task Details" width="800" data-testid="tasklist__view-drawer">
      <template v-slot:body>
        <div class="d-flex body-1 mb-4" data-testid="tasklist__view-drawer-header">
          <span class="radius-mini text-body-2 purple--text pa-2 mr-3 font-weight-bold" style="height:30px; background:#F4F4FB" data-testid="tasklist__view-drawer-ref">{{ viewchecklistdata.ref }}</span>
          <div class="black--text text-font-size-md font-weight-bold" data-testid="tasklist__view-drawer-description">{{ viewchecklistdata.description || "" }}</div>
        </div>
        <div :style="{ height: `${fixedDivHeight}px` }" data-testid="tasklist__view-drawer-spacer"></div>
        <div data-testid="tasklist__view-drawer-content">
          <div style="height:4.5vh" class="d-flex" data-testid="tasklist__view-drawer-due-days-row">
            <p class="ml-1">Due Days</p>
            <p>
              <span class="dueDate ml-2 my-3" style="margin-left:47px !important" data-testid="tasklist__view-drawer-due-days-value">
                <v-icon color="caccounting" class="pr-1">mdi-calendar-blank</v-icon>
                {{ viewchecklistdata.duedays || 'No data' }} Days
              </span>
            </p>
          </div>
          <v-table data-testid="tasklist__view-drawer-table">
            <template>
              <tbody class="ma-3" data-testid="tasklist__view-drawer-table-body">
                <v-slide-y-transition>
                  <div v-if="showMore" data-testid="tasklist__view-drawer-table-details">
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-task-type-row">
                      <td class="ml-3">Task Type</td>
                      <td>
                        <span class="ml-2 radius-small font-size-xm pa-2 black--text thead-color" style="margin-left:30px !important" data-testid="tasklist__view-drawer-table-task-type-value">
                          {{ viewchecklistdata.task_type || 'No data' }}
                        </span>
                      </td>
                    </tr>
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-category-row">
                      <td class="ml-3">Category</td>
                      <td>
                        <span class="ml-2 radius-small font-size-xm pa-2 black--text thead-color" style="margin-left:30px !important" data-testid="tasklist__view-drawer-table-category-value">
                          {{ viewchecklistdata.category || 'No data' }}
                        </span>
                      </td>
                    </tr>
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-subcategory-row">
                      <td class="ml-3">Sub Category</td>
                      <td>
                        <span class="ml-2 radius-small font-size-xm pa-2 black--text thead-color" style="margin-left:30px !important" data-testid="tasklist__view-drawer-table-subcategory-value">
                          {{ viewchecklistdata.subcategory || 'No data' }}
                        </span>
                      </td>
                    </tr>
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-assertions-row">
                      <td class="ml-3">Assertions</td>
                      <td style="margin-left:30px !important" class="d-flex">
                        <template v-if="viewchecklistdata.assertions.length > 0">
                          <p v-for="(item, index) in viewchecklistdata.assertions" :key="index" class="light-purple-background radius-mini font-size-xm purple--text pa-1 mr-2" :data-testid="`tasklist__view-drawer-table-assertion-item-${index}`">
                            {{ item }}
                          </p>
                        </template>
                        <template v-else>
                          <p class="font-size-xm pt-2 pa-1 mr-2 black--text mx-1" data-testid="tasklist__view-drawer-table-assertion-empty">No data</p>
                        </template>
                      </td>
                    </tr>
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-tags-row">
                      <td class="ml-3">Tags</td>
                      <td style="margin-left:32px !important" class="d-flex">
                        <template v-if="viewchecklistdata.tags.length > 0">
                          <p v-for="(item, index) in viewchecklistdata.tags" :key="index" class="light-purple-background radius-mini font-size-xm purple--text pa-1 mr-2" :data-testid="`tasklist__view-drawer-table-tag-item-${index}`">
                            {{ item }}
                          </p>
                        </template>
                        <template v-else>
                          <p class="font-size-xm pt-2 pa-1 mr-2 black--text mx-1" data-testid="tasklist__view-drawer-table-tag-empty">No data</p>
                        </template>
                      </td>
                    </tr>
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-purpose-row">
                      <td class="ml-3">Purpose</td>
                      <td>
                        <span class="ml-2 radius-small font-size-xm pa-2 black--text" style="margin-left:30px !important" data-testid="tasklist__view-drawer-table-purpose-value">
                          {{ viewchecklistdata.purpose || 'No data' }}
                        </span>
                      </td>
                    </tr>
                    <tr style="height:4.5vh" data-testid="tasklist__view-drawer-table-instruction-row">
                      <td class="ml-3">Instruction</td>
                      <td>
                        <span class="ml-2 radius-small font-size-xm pa-2 black--text" style="margin-left:30px !important" data-testid="tasklist__view-drawer-table-instruction-value">
                          {{ viewchecklistdata.instruction || 'No data' }}
                        </span>
                      </td>
                    </tr>
                    <!-- Adding custom columns  -->
                    <tr v-for="field in customColumns" :key="field.columnName" style="height:4.5vh" :data-testid="`tasklist__view-drawer-table-customcol-row-${field.columnName}`">
                      <td class="ml-3">{{ field.displayText }}</td>
                      <td>
                        <span class="ml-2 radius-small font-size-xm pa-2 black--text" style="margin-left:30px !important" :data-testid="`tasklist__view-drawer-table-customcol-value-${field.columnName}`">
                          {{ viewchecklistdata[field.columnName] || 'No data' }}
                        </span>
                      </td>
                    </tr>
                  </div>
                </v-slide-y-transition>
                <tr data-testid="tasklist__view-drawer-table-toggle-row">
                  <td>
                    <v-btn @click="showMore = !showMore" color="white" class="pa-0" data-testid="tasklist__view-drawer-table-toggle-btn">
                      <v-icon data-testid="tasklist__view-drawer-table-toggle-icon">{{ showMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon>
                      <p class="ma-0 pa-0 text-button px-1 black--text" data-testid="tasklist__view-drawer-table-toggle-label">
                        {{ showMore ? 'Hide items' : '6 more itmes' }}
                      </p>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-table>
          <v-row class="pb-2" data-testid="tasklist__view-drawer-location-users-panel">
            <v-col cols="12" class="mt-4 py-0">
              <div class="body-2 font-weight-bold black--text pt-3 pb-1" data-testid="tasklist__view-drawer-location-users-title">Location & Users</div>
              <v-row class="my-2 d-flex align-center">
                <v-row class="my-2 d-flex align-center" v-if="viewchecklistdata.locationlist">
                  <v-col cols="4" v-for="(item, index) in displayedLocations" :key="index" :data-testid="`tasklist__view-drawer-location-users-locationcol-${index}`">
                    <v-col class="d-flex flex-column pa-0 ma-0 radius-small border-on mx-1" data-testid="tasklist__view-drawer-location-users-locationcol-inner">
                      <div class="d-flex align-center py-1 tableHeaderBg justify-space-between" style="border-radius:8px 8px 0px 0px" data-testid="tasklist__view-drawer-location-users-locationcol-header">
                        <p class="ma-0 pa-0 px-2 text-font-size-md black--text">{{ getLocationName(item.location_id || "") }}</p>
                      </div>
                      <div class="d-flex pa-2" data-testid="tasklist__view-drawer-location-users-preparer-row">
                        <p class="ma-0 pa-0 pr-3">Preparer</p>
                        <div class="d-flex all-width">
                          <div class="d-flex">
                            <div v-for="(preparer, index) in item.preparer.slice(0, 3)" :key="index" class="avatars-group__item" :data-testid="`tasklist__view-drawer-location-users-preparer-avatar-${index}`">
                              <v-tooltip top content-class="tooltip-top">
                                <template v-slot:activator="{ on }">
                                  <v-avatar v-on="on" size="27" color="caccounting" class="white--text border-on d-flex pa-0 ma-0 v-avatar">
                                    {{ getPreparesName(preparer).split(' ').slice(0, 2).map(word => word[0].toUpperCase()).join('') }}
                                  </v-avatar>
                                </template>
                                <span>{{ getPreparesName(preparer) }}</span>
                              </v-tooltip>
                            </div>
                            <v-tooltip v-if="item.preparer.length > 3 && item.preparer.length < 8" top content-class="tooltip-top">
                              <template v-slot:activator="{ on, attrs }">
                                <v-avatar v-bind="attrs" v-on="on" size="25" color="lightpurple" style="margin-left:-6px !important" class="caccounting--text d-flex align-center justify-center pa-0 ma-0" data-testid="tasklist__view-drawer-location-users-preparer-plus-avatar">
                                  <v-icon color="caccounting">mdi-plus</v-icon>
                                </v-avatar>
                              </template>
                              <div v-for="(name, index) in item.preparer.slice(3)" :key="index" :data-testid="`tasklist__view-drawer-location-users-preparer-plus-item-${index}`">
                                <span>{{ getPreparesName(name) }}</span>
                              </div>
                            </v-tooltip>
                            <v-menu v-else-if="item.preparer.length >= 8" :close-on-content-click="false" offset-y color="white" class="pa-0 ma-0" style="background-color:white" data-testid="tasklist__view-drawer-location-users-preparer-menu">
                              <template v-slot:activator="{ on, attrs }">
                                <v-avatar size="25" color="lightpurple" class="caccounting--text d-flex align-center justify-center pa-0 ma-0" v-bind="attrs" v-on="on" style="margin-left:-6px !important">
                                  <v-icon color="caccounting">mdi-plus</v-icon>
                                </v-avatar>
                              </template>
                              <v-list class="overflow-scroll radius-small pa-0 pt-2 mb-0" style="min-width:18vh; max-height:20vh">
                                <div class="overflow-scroll px-2 userMenu">
                                  <v-list-item v-for="(item, index) in item.preparer.slice(3)" :key="index" style="background-color:white" class="pa-0" :data-testid="`tasklist__view-drawer-location-users-preparer-menu-item-${index}`">
                                    <v-list-item-content class="pa-0 ma-0">
                                      <span>{{ getPreparesName(preparer) }}</span>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </v-list>
                            </v-menu>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex pa-2" data-testid="tasklist__view-drawer-location-users-approver-row">
                        <p class="ma-0 pa-0 pr-3">Approver</p>
                        <div class="d-flex all-width">
                          <div class="d-flex">
                            <div v-for="(approver, index) in item.approver.slice(0, 3)" :key="index" class="avatars-group__item" :data-testid="`tasklist__view-drawer-location-users-approver-avatar-${index}`">
                              <v-tooltip top content-class="tooltip-top">
                                <template v-slot:activator="{ on }">
                                  <v-avatar v-on="on" size="27" color="caccounting" class="white--text border-on d-flex pa-1 ma-0 v-avatar">
                                    {{ getApproversName(approver).split(' ').slice(0, 2).map(word => word[0].toUpperCase()).join('') }}
                                  </v-avatar>
                                </template>
                                <span>{{ getApproversName(approver) }}</span>
                              </v-tooltip>
                            </div>
                            <v-tooltip v-if="item.approver.length > 3 && item.approver.length < 8" top content-class="tooltip-top">
                              <template v-slot:activator="{ on, attrs }">
                                <v-avatar v-bind="attrs" v-on="on" size="25" color="lightpurple" style="margin-left:-6px !important" class="caccounting--text d-flex align-center justify-center pa-0 ma-0" data-testid="tasklist__view-drawer-location-users-approver-plus-avatar">
                                  <v-icon color="caccounting">mdi-plus</v-icon>
                                </v-avatar>
                              </template>
                              <div v-for="(name, index) in item.approver.slice(3)" :key="index" :data-testid="`tasklist__view-drawer-location-users-approver-plus-item-${index}`">
                                <span>{{ getApproversName(name) }}</span>
                              </div>
                            </v-tooltip>
                            <v-menu v-else-if="item.approver.length >= 8" :close-on-content-click="false" offset-y color="white" class="pa-0 ma-0" style="background-color:white" data-testid="tasklist__view-drawer-location-users-approver-menu">
                              <template v-slot:activator="{ on, attrs }">
                                <v-avatar size="25" color="lightpurple" class="caccounting--text d-flex align-center justify-center pa-0 ma-0" v-bind="attrs" v-on="on" style="margin-left:-6px !important">
                                  <v-icon color="caccounting">mdi-plus</v-icon>
                                </v-avatar>
                              </template>
                              <v-list class="overflow-scroll radius-small pa-0 pt-2 mb-0" style="min-width:18vh; max-height:20vh">
                                <div class="px-2 userMenu">
                                  <v-list-item v-for="(item, index) in item.approver.slice(3)" :key="index" style="background-color:white" class="pa-0" :data-testid="`tasklist__view-drawer-location-users-approver-menu-item-${index}`">
                                    <v-list-item-content class="pa-0 ma-0">
                                      <span>{{ getApproversName(item) }}</span>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </v-list>
                            </v-menu>
                          </div>
                        </div>
                      </div>
                      <!-- Threshold status (Account Reconciliation only) -->
                      <div class="d-flex align-center justify-space-between px-2 py-1 border-top"
                        v-if="viewchecklistdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                        data-testid="tasklist__view-drawer-location-users-threshold-row">
                        <span class="text-caption">Threshold Enforcement</span>
                        <v-chip small :color="item.skipValidations ? 'grey lighten-1' : 'success'" :text-color="item.skipValidations ? 'grey darken-2' : 'white'"
                          data-testid="tasklist__view-drawer-location-users-threshold-chip">
                          {{ item.skipValidations ? 'Disabled' : 'Enabled' }}
                        </v-chip>
                      </div>
                    </v-col>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center" v-if="viewchecklistdata.locationlist.length > 6">
                    <v-btn @click="showAll = !showAll" class="d-flex align-center justify-center pa-0 px-1 border-on" style="background:white;" data-testid="tasklist__view-drawer-location-users-toggle-btn">
                      <v-icon class="pr-1" data-testid="tasklist__view-drawer-location-users-toggle-icon">{{ showAll ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      <p class="ma-0 pa-0" v-if="!showAll" data-testid="tasklist__view-drawer-location-users-toggle-label-more">{{ viewchecklistdata.locationlist.length - 6 }} more locations</p>
                      <p class="ma-0 pa-0" v-else data-testid="tasklist__view-drawer-location-users-toggle-label-less">Show Less</p>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="4" class="mx-3" data-testid="tasklist__view-drawer-location-users-empty">No data</v-col>
                </v-row>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-2 py-0">
              <div class="d-flex align-center">
                <div class="body-2 font-weight-bold py-2 black--text" data-testid="tasklist__view-drawer-gl-title">Linked Gl's</div>
                <v-spacer></v-spacer>
              </div>
            </v-col>
            <v-col cols="12" class="radius-small py-0">
              <v-simple-table class="border-on radius-small" v-if="viewchecklistdata.glcode !== undefined && viewchecklistdata.glcode?.length !== 0" data-testid="tasklist__view-drawer-gl-table">
                <template>
                  <thead class="border-bottom tableHeaderBg">
                    <th class="thead-color text-start px-2 py-2">Gl Code</th>
                    <th class="thead-color text-start px-2 py-2">Name</th>
                    <th class="thead-color text-start px-2 py-2">Category</th>
                    <th class="thead-color text-start px-2 py-2">Sub Category</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in viewchecklistdata.glcode" :key="index" :data-testid="`tasklist__view-drawer-gl-table-row-${index}`">
                      <td class="text-start px-2" data-testid="tasklist__view-drawer-gl-table-glcode">{{ item.glcode }}</td>
                      <td class="text-start px-2" data-testid="tasklist__view-drawer-gl-table-name">{{ item.name }}</td>
                      <td class="text-start px-2" data-testid="tasklist__view-drawer-gl-table-category">{{ item.category }}</td>
                      <td class="text-start px-2" data-testid="tasklist__view-drawer-gl-table-subcategory">{{ item.subcategory }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <p v-else data-testid="tasklist__view-drawer-gl-table-empty">No Data</p>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:actions>
        <v-row class="my-1 px-2 d-flex align-center justify-center" data-testid="tasklist__view-drawer-actions-row">
          <p class="ma-0">*Required</p>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addEditForm(viewchecklistdata)" class="white--text" data-testid="tasklist__view-drawer-edit-btn"><span>Edit Task</span></v-btn>
        </v-row>
      </template>
    </lb-drawer>

    <lb-drawer v-model="addeditdialog" :heading="addeditdata._id ? 'Edit Task' : 'Create New Task'" width="60%"
      :loading="addeditloading" @drawer-closed="resetTaskForm()" data-testid="tasklist__add-edit-drawer"
       >
      
      <template v-slot:body>
        <div data-testid="tasklist__add-edit-drawer-body">
          <v-row>
            <v-col cols="12" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md mb-1">Task Description*</p>
              <lb-textBox v-model="addeditdata.description" label="" requriedrows="3" :hidedetails="true"
                :error="addeditdataerror.description" data-testid="tasklist__add-edit-drawer-description" />
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md">Task Type*</p>
              <lb-dropdown label="" :multiple="false" :multiplechips="false" v-model="addeditdata.task_type"
                appendiconinner="mdi-chevron-down" :hidedetails="true" :error="addeditdataerror.task_type"
                :items="taskTypes" itemtext="name" itemvalue="value" data-testid="tasklist__add-edit-drawer-task-type" />
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md">Cycle Type*</p>
              <lb-tagsInput :multiple="false" :multiplechips="false" v-model="addeditdata.cycle_type"
                appendiconinner="mdi-chevron-down" :error="addeditdataerror.cycle_type"
                :items="cycleTypes.map((item)=> item.name)"  item-class="noTransform" data-testid="tasklist__add-edit-drawer-cycle-type" />
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md">Category*</p>
              <lb-dropdown v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                :multiple="false" v-model="addeditdata.category"
                appendiconinner="mdi-chevron-down" :error="addeditdataerror.category"
                :items="coaCategoryAcc" label="" data-testid="tasklist__add-edit-drawer-category" />
              <lb-tagsInput v-else :multiple="false" :multiplechips="false" v-model="addeditdata.category"
                appendiconinner="mdi-chevron-down" :error="addeditdataerror.category"
                :items="categoryAcc" data-testid="tasklist__add-edit-drawer-category" />
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md">Sub Category*</p>
              <lb-dropdown v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                :multiple="false" v-model="addeditdata.subcategory"
                appendiconinner="mdi-chevron-down" :error="addeditdataerror.subcategory"
                :items="coaSubcategoryAcc" label="" data-testid="tasklist__add-edit-drawer-subcategory" />
              <lb-tagsInput v-else :multiple="false" :multiplechips="false" v-model="addeditdata.subcategory"
                 :error="addeditdataerror.subcategory" :items="subcategoryAcc" appendiconinner="mdi-chevron-down" data-testid="tasklist__add-edit-drawer-subcategory"/>
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md">Add Assertions</p>
              <lb-tagsInput v-model="addeditdata.assertions" :hidedetails="true" :items="possibleassertions" label=""
                :error="addeditdataerror.assertions" tagcolor="purpleborder" :multiple="true" :multiplechips="true" appendiconinner="mdi-chevron-down" data-testid="tasklist__add-edit-drawer-assertions" />
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="pa-0 ma-0  text-font-size-md">Tags*</p>
              <lb-tagsInput tagcolor="purpleborder" :multiple="true" v-model="addeditdata.tags" :multiplechips="true"
                 :items="Alltags" :error="addeditdataerror.tags" appendiconinner="mdi-chevron-down" data-testid="tasklist__add-edit-drawer-tags"/>
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="ma-0 pa-0  text-font-size-md">Purpose</p>
              <lb-textBox v-model="addeditdata.purpose" label="" height='100' :hidedetails="true" requriedrows="3"
                :error="addeditdataerror.purpose" data-testid="tasklist__add-edit-drawer-purpose" />
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="ma-0 pa-0  text-font-size-md"> Instruction</p>
              <lb-textBox v-model="addeditdata.instruction" label="" :error="addeditdataerror.instruction" height="100" requriedrows="3"
                :hidedetails="true" data-testid="tasklist__add-edit-drawer-instruction" />
            </v-col>
            <v-col cols="6" class="my-1 mb-3 py-1">
              <p class="ma-0 pa-0  text-subtitle-1">Due Days</p>
              <lb-string :placeholder="`Enter value between -${$options.MAX_DUE_DATE_DAYS} and ${$options.MAX_DUE_DATE_DAYS}`" label=""
                :value="addeditdata.duedays != null ? String(addeditdata.duedays) : ''"
                @input="v => { addeditdata.duedays = v; validateDueDayInput(v); }"
                :error="addeditdataerror.duedays" 
                data-testid="tasklist__add-edit-drawer-due-days"/>
              <span class="font-size-xm gray--text">Enter the number of days to set the due date automatically based on the cycle ending date.</span>
            </v-col>
            <v-col cols="6" class="my-1 py-1">
              <p class="ma-0 pa-0  text-font-size-md">Priority*</p>
              <lb-dropdown v-model="addeditdata.priority" :items="priorityList" :error="addeditdataerror.priority"
                label="" data-testid="tasklist__add-edit-drawer-priority" />
            </v-col>
            <v-col cols="12" class="my-1 py-1">
              <p class="ma-0 pa-0  text-font-size-md">No. of Evidences</p>
              <v-text-field
                  v-model.number="addeditdata.no_of_evidence"
                  type="number"
                  :min="0"
                  :max="10"
                  :step="1"
                  outlined
                  dense
                  :error-messages="addeditdataerror.no_of_evidence"
                  @input="onEvidenceInput"
                  data-testid="tasklist__add-edit-drawer-no-of-evidences"
                />
            </v-col>
          </v-row>
          <p class="pa-0 ma-0 mb-1  text-subtitle-1 mx-1">{{$store.state.LocationHeader|| 'Location'}} and Users*</p>
          <!-- After adding locations and users , Display the selected locations and users list -->
          <v-row class="mb-3 d-flex align-center" v-if="locationUserList.length > 0" data-testid="tasklist__add-edit-drawer-location-users-panel">
            <v-col cols="4" v-for="(item, index) in locationUserList.slice(0, visibleRowsitems)" :key="index" data-testid="tasklist__add-edit-drawer-location-users-col">
              <v-col class="d-flex flex-column pa-0 ma-0 radius-small border-on mx-1">
                <div class="d-flex align-center py-1 tableHeaderBg justify-space-between"
                  style="border-radius:8px 8px 0px 0px">
                  <p class="ma-0 pa-0 px-2 text-font-size-md black--text">{{ getlocationNamebyId(item.location_id) }}</p>
                  <v-btn icon @click="deleteLocation(item.location_id)" data-testid="tasklist__add-edit-drawer-location-users-delete-btn">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </div>
                <!-- Edit Location and User -->
                <lb-profilestack :items="item.preparer" :v-model="addPrepares" :updateFunction="addEditItem" :activeUsers="userDetails.activeUsers"
                  heading="Preparer" :allUser="formdata.users" data-testid="tasklist__add-edit-drawer-location-users-preparer" />
                <lb-profilestack :items="item.approver" :v-model="addApprover" :updateFunction="addEditItem" :activeUsers="userDetails.activeUsers"
                  heading="Approver" :allUser="formdata.users" data-testid="tasklist__add-edit-drawer-location-users-approver" />
                <!-- Threshold Enforcement (Account Reconciliation only) -->
                <div class="d-flex align-center justify-space-between px-2 py-1 border-top"
                  v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION">
                  <div class="d-flex align-center">
                    <span class="">{{ item.skipValidations ? 'Threshold Disabled' : 'Threshold Enabled' }}</span>
                  </div>
                  <v-switch
                    :input-value="item.skipValidations"
                    @change="(val) => $set(item, 'skipValidations', !!val)"
                    inset dense color="primary"
                    class="mt-0 pt-0 flex-shrink-0"
                    hide-details
                    data-testid="tasklist__add-edit-drawer-location-users-skip-validations"
                  />
                </div>
              </v-col>
            </v-col>

            <v-col class="mx-4  my-0 py-1 d-flex align-center justify-center all-width" data-testid="tasklist__add-edit-drawer-location-users-add-new-col">
              <div class="d-flex flex-column align-center">
                <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="slide-y-transition" data-testid="tasklist__add-edit-drawer-location-users-add-new-menu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white all-height blue--text font-size-xm" v-bind="attrs" v-on="on" data-testid="tasklist__add-edit-drawer-location-users-add-new-btn">
                      <v-icon class="px-2">mdi-plus-circle-outline</v-icon>
                      <p class="ma-0 pa-0"> Add New</p>
                    </v-btn>
                  </template>

                  <v-list style="max-height:50vh ; overflow:hidden" class="pa-0 mas-0" data-testid="tasklist__add-edit-drawer-location-users-add-new-list">
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between"
                      v-if="locationUserDropdown === 0" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-location-title">
                      <p class="ma-1 pa-0">Choose {{$store.state.LocationHeader|| 'Location'}}</p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between"
                      v-if="locationUserDropdown === 1" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-preparer-title">
                      <p class="ma-1 pa-0">Select Preparer</p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between"
                      v-if="locationUserDropdown === 2" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-approver-title">
                      <p class="ma-1 pa-0">Select Approver </p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between"
                      v-if="locationUserDropdown === 3 && isEditingReconTask" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-threshold-title">
                      <p class="ma-1 pa-0">Threshold Enforcement</p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>

                    <v-divider></v-divider>
                    <v-list-item style="max-height:20vh ; overflow:scroll"
                      class="d-flex align-start pa-0 ma-0 flex-column" v-if="locationUserDropdown === 0">
                      <v-list-item v-for="(item) in filteredUniqueLocations" class="d-flex " :key="item._id">
                        <v-checkbox color="caccounting" class="ma-0 pa-0" hide-details 
                          v-model="addLocation" :value="item" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-location-checkbox"><template v-slot:label><span>{{ item.name }}</span></template></v-checkbox>
                      </v-list-item>

                    </v-list-item>
                    <v-list-item style="max-height:20vh ; overflow:scroll"
                      class="d-flex align-start pa-0 ma-0 flex-column px-1" v-if="locationUserDropdown === 1">
                      <lb-string label="" placeholder="Search" v-model="searchusername" :hidedetails="true"
                          appendinnericon="mdi-magnify" class="mt-1 all-width" />
                        <div class="d-flex flex-wrap align-start flex-direction-column">
                          <template v-for="(item, index) in filteredActiveUsers">
                            <v-checkbox
                              :label="item.name"
                              :key="index"
                              class="pa-2 ma-1"
                              :input-value="addPrepares.includes(item._id)"
                              @change="togglePreparer(item._id)"
                              color="caccounting"
                              hide-details
                            >
                              <template v-slot:label>
                                <span :class="{ 'inactive-user-label': item?.inactive }">{{ item.name }}</span>
                              </template>
                            </v-checkbox>
                          </template>
                        </div>

                    </v-list-item>
                    <v-list-item style="max-height:20vh ; overflow:scroll"
                      class="d-flex align-start pa-0 ma-0 flex-column" v-if="locationUserDropdown === 2">
                     <lb-string label="" placeholder="Search" v-model="searchusername" :hidedetails="true"
                          appendinnericon="mdi-magnify" class="mt-1 all-width" />
                        <div class="d-flex flex-wrap align-start flex-direction-column">
                          <template v-for="(item, index) in filteredActiveUsers.filter(user => !addPrepares.includes(user._id))">
                            <v-checkbox
                              :label="item.name"
                              :key="index"
                              class="pa-2 ma-1"
                              :input-value="addApprover.includes(item._id)"
                              @change="toggleApprover(item._id)"
                              color="caccounting"
                              hide-details
                            >
                              <template v-slot:label>
                                <span :class="{ 'inactive-user-label': item?.inactive }">{{ item.name }}</span>
                              </template>
                            </v-checkbox>
                          </template>
                        </div>

                    </v-list-item>
                    <v-list-item class="d-flex align-start pa-0 ma-0 flex-column" v-if="locationUserDropdown === 3 && isEditingReconTask"
                      data-testid="tasklist__add-edit-drawer-location-users-add-new-list-threshold-item">
                      <v-row no-gutters class="pa-2 all-width gap-2">
                        <v-col cols="12">
                          <v-card outlined :class="['enable-disable-radio-card pa-3', locationUserSkipValidation === true ? 'enable-disable-radio-card--selected' : '']"
                            @click="locationUserSkipValidation = true">
                            <div class="d-flex align-center">
                              <v-icon class="mr-2 flex-shrink-0" :color="locationUserSkipValidation === true ? 'primary' : 'grey lighten-1'">
                                {{ locationUserSkipValidation === true ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                              </v-icon>
                              <div>
                                <p class="font-weight-medium mb-0 text-body-2">Enable Threshold Enforcement</p>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card outlined :class="['enable-disable-radio-card pa-3', locationUserSkipValidation === false ? 'enable-disable-radio-card--selected' : '']"
                            @click="locationUserSkipValidation = false">
                            <div class="d-flex align-center">
                              <v-icon class="mr-2 flex-shrink-0" :color="locationUserSkipValidation === false ? 'primary' : 'grey lighten-1'">
                                {{ locationUserSkipValidation === false ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                              </v-icon>
                              <div>
                                <p class="font-weight-medium mb-0 text-body-2">Disable Threshold Enforcement</p>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <div class="d-flex justify-space-between" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-actions">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="nextStepforLocation(++locationUserDropdown);searchusername=''"
                        v-if="locationUserDropdown < (isEditingReconTask ? 3 : 2)" class="ma-1" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-next-button"><span>Next</span></v-btn>
                      <v-btn color="primary" class="ma-1" v-if="locationUserDropdown === 3 || (locationUserDropdown === 2 && !isEditingReconTask)"
                        @click="addUserLocation(addLocation, addPrepares, addApprover, locationUserSkipValidation);locationUserDropdown=0" data-testid="tasklist__add-edit-drawer-location-users-add-new-list-submit-button"><span>Submit</span></v-btn>
                    </div>
                  </v-list>
                </v-menu>
                <span v-if="addeditdataerror.location_users" class="error--text">{{ addeditdataerror.location_users[0] }}</span> 
              </div>
            </v-col>

          </v-row>
          <!-- Before adding locations and users -->
          <v-row v-else data-testid="tasklist__add-edit-drawer-location-users-empty-panel">
            <v-col class="mx-4 dashed_border mt-3 my-3 py-1 d-flex align-center justify-center all-width" :class="{'mandatory-error-border': addeditdataerror.location_users}" data-testid="tasklist__add-edit-drawer-location-users-empty-col">
              <div>
                <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="slide-y-transition" data-testid="tasklist__add-edit-drawer-location-users-empty-menu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white all-height blue--text font-size-xm" v-bind="attrs" v-on="on" data-testid="tasklist__add-edit-drawer-location-users-empty-btn">
                      <v-icon class="px-2" data-testid="tasklist__add-edit-drawer-location-users-empty-btn-icon">mdi-plus-circle-outline</v-icon>
                      <p class="ma-0 pa-0" data-testid="tasklist__add-edit-drawer-location-users-empty-btn-label">Add {{$store.state.LocationHeader|| 'Location' }} and users</p>
                    </v-btn>
                  </template>

                  <v-list style="overflow:hidden" class="pa-0 mas-0" data-testid="tasklist__add-edit-drawer-location-users-empty-list max-height-40">
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between" v-if="locationUserDropdown === 0" data-testid="tasklist__add-edit-drawer-location-users-empty-list-location-title">
                      <p class="ma-1 pa-0">Choose {{$store.state.LocationHeader|| 'Location'}}</p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between" v-if="locationUserDropdown === 1" data-testid="tasklist__add-edit-drawer-location-users-empty-list-preparer-title">
                      <p class="ma-1 pa-0">Select Preparer</p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between" v-if="locationUserDropdown === 2" data-testid="tasklist__add-edit-drawer-location-users-empty-list-approver-title">
                      <p class="ma-1 pa-0">Select Approver </p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>
                    <div class="font-weight-bold text-subtitle px-4 py-2 d-flex justify-space-between" v-if="locationUserDropdown === 3 && isEditingReconTask" data-testid="tasklist__add-edit-drawer-location-users-empty-list-threshold-title">
                      <p class="ma-1 pa-0">Select Threshold Enforcement</p>
                      <v-icon>mdi-information-outline</v-icon>
                    </div>

                    <v-divider></v-divider>
                    <v-list-item style="max-height:20vh ; overflow:scroll" class="d-flex align-start pa-0 ma-0 flex-column" v-if="locationUserDropdown === 0" data-testid="tasklist__add-edit-drawer-location-users-empty-list-location-item">
                      <v-list-item v-for="(item) in filteredUniqueLocations" class="d-flex" :key="item._id" :data-testid="`tasklist__add-edit-drawer-location-users-empty-list-location-row-${item._id}`">
                        <v-checkbox color="caccounting" class="ma-0 pa-0" hide-details v-model="addLocation" :value="item" data-testid="tasklist__add-edit-drawer-location-users-empty-list-location-checkbox">
                          <template v-slot:label><span>{{ item.name }}</span></template>
                        </v-checkbox>
                      </v-list-item>
                    </v-list-item>
                    <v-list-item style="max-height:20vh ; overflow:scroll"
                      class="d-flex align-start pa-0 ma-0 flex-column px-1" v-if="locationUserDropdown === 1">
                        <lb-string label="" placeholder="Search" v-model="searchusername" :hidedetails="true"
                          appendinnericon="mdi-magnify" class="mt-1 all-width" />
                        <div class="d-flex flex-wrap align-start flex-direction-column">
                          <template v-for="(item, index) in filteredActiveUsers">
                            <v-checkbox
                              :label="item.name"
                              :key="index"
                              class="pa-2 ma-1"
                              :input-value="addPrepares.includes(item._id)"
                              @change="togglePreparer(item._id)"
                              color="caccounting"
                              hide-details
                            >
                              <template v-slot:label>
                                <span :class="{ 'inactive-user-label': item?.inactive }">{{ item.name }}</span>
                              </template>
                            </v-checkbox>
                          </template>
                        </div>
                      </v-list-item>
                    <v-list-item style="max-height:20vh ; overflow:scroll"
                      class="d-flex align-start pa-0 ma-0 flex-column px-1" v-if="locationUserDropdown === 2">
                      <lb-string label="" placeholder="Search" v-model="searchusername" :hidedetails="true"
                        appendinnericon="mdi-magnify" class="mt-1 all-width" data-testid="tasklist__add-edit-drawer-location-users-empty-list-approver-search" />
                       <div class="d-flex flex-wrap align-start flex-direction-column">
                        <template v-for="(item, index) in filteredActiveUsers.filter((user)=> !addPrepares.includes(user._id))">
                          <v-checkbox
                            :label="item.name"
                            :key="index"
                            class="pa-2 ma-1"
                            :input-value="addApprover.includes(item._id)"
                            @change="toggleApprover(item._id)"
                            color="caccounting"
                            hide-details
                          >
                          <template v-slot:label>
                            <span :class="{ 'inactive-user-label': item?.inactive }">{{ item.name }}</span>
                          </template>
                        </v-checkbox>
                        </template>
                      </div>
                      </v-list-item>

                    <v-list-item class="d-flex align-start pa-0 ma-0 flex-column" v-if="locationUserDropdown === 3 && isEditingReconTask"
                      data-testid="tasklist__add-edit-drawer-location-users-empty-list-threshold-item">
                      <v-row no-gutters class="pa-2 all-width gap-2">
                        <v-col cols="12" class="">
                          <v-card outlined :class="['enable-disable-radio-card pa-3', locationUserSkipValidation === true ? 'enable-disable-radio-card--selected' : '']"
                            @click="locationUserSkipValidation = true">
                            <div class="d-flex align-center">
                              <v-icon class="mr-2 flex-shrink-0" :color="locationUserSkipValidation === true ? 'primary' : 'grey lighten-1'">
                                {{ locationUserSkipValidation === true ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                              </v-icon>
                              <div>
                                <p class="font-weight-medium mb-0 text-body-2">Enable</p>
                                <p class="text-caption grey--text mb-0">Apply standard validation</p>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12" class="">
                          <v-card outlined :class="['enable-disable-radio-card pa-3', locationUserSkipValidation === false ? 'enable-disable-radio-card--selected' : '']"
                            @click="locationUserSkipValidation = false">
                            <div class="d-flex align-center">
                              <v-icon class="mr-2 flex-shrink-0" :color="locationUserSkipValidation === false ? 'primary' : 'grey lighten-1'">
                                {{ locationUserSkipValidation === false ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                              </v-icon>
                              <div>
                                <p class="font-weight-medium mb-0 text-body-2">Disable</p>
                                <p class="text-caption grey--text mb-0">Skip validation</p>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <div class="d-flex justify-space-between" data-testid="tasklist__add-edit-drawer-location-users-empty-list-actions">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="nextStepforLocation(++locationUserDropdown);searchusername=''" v-if="locationUserDropdown < (isEditingReconTask ? 3 : 2)" class="ma-1 white--text" data-testid="tasklist__add-edit-drawer-location-users-empty-list-next-btn"><span>Next</span></v-btn>
                      <v-btn color="primary" class="ma-1 white--text" v-if="locationUserDropdown === 3 || (locationUserDropdown === 2 && !isEditingReconTask)" @click="addUserLocation(addLocation, addPrepares, addApprover, locationUserSkipValidation);locationUserDropdown=0" data-testid="tasklist__add-edit-drawer-location-users-empty-list-submit-btn"><span>Submit</span></v-btn>
                    </div>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>


          <v-row class="mx-auto all-width align-center justify-center mt-2" data-testid="tasklist__add-edit-drawer-location-users-toggle-panel">
            <v-btn class="d-flex align-center justify-center pa-0 px-1 border-on" style="background:white;"
              v-if="locationUserList.length > 6 && visibleRowsitems < locationUserList.length" @click="showMoreRows"
              data-testid="tasklist__add-edit-drawer-location-users-toggle-more-btn">
              <span data-testid="tasklist__add-edit-drawer-location-users-toggle-more-label">See {{ locationUserList.length - visibleRowsitems }} More items</span>
              <v-icon class="pr-1" data-testid="tasklist__add-edit-drawer-location-users-toggle-more-icon">mdi-chevron-down </v-icon>
            </v-btn>
            <v-btn class="d-flex align-center justify-center pa-0 px-1 border-on" style="background:white;"
              v-if="visibleRowsitems > 6" @click="showLessRows"
              data-testid="tasklist__add-edit-drawer-location-users-toggle-less-btn">
              <span data-testid="tasklist__add-edit-drawer-location-users-toggle-less-label">See Less</span>
              <v-icon class="pr-1" data-testid="tasklist__add-edit-drawer-location-users-toggle-less-icon">mdi-chevron-up</v-icon>
            </v-btn>
          </v-row>
          <v-row v-if="addeditdata?.task_type && addeditdata?.task_type !== $constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL">
            <v-col cols="12" class="my-0 mt-3 py-" >
              <p class="ma-0 py-2 pa-0">Account No</p>
              <lb-dropdown v-model="addeditdata.glcode" :items="possibleGlCodes" multiple label=""
                :error="addeditdataerror.glcode" :key="new Date().getTime()" data-testid="tasklist__add-edit-drawer-account-no-dropdown" />
            </v-col>
            <!-- <v-col cols="12" class="my-1 py-1">
              <v-card flat outlined rounded="lg" class="px-3 py-3">
                <div class="d-flex align-center gap-2">
                  <div class="d-flex align-center justify-center">
                    <v-icon :color="addeditdata.skipValidations ? 'success' : 'grey'" size="20">{{ addeditdata.skipValidations ? 'mdi-shield-check-outline' : 'mdi-shield-off-outline' }}</v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <p class="font-weight-medium mb-0">{{ addeditdata.skipValidations ? 'Threshold Enforcement Enabled' : 'Threshold Enforcement Disabled' }}</p>
                    <p class="text-caption grey--text mb-0">{{ addeditdata.skipValidations ? 'Applies standard attachment and threshold validations' : 'Bypasses attachment and threshold validations' }}</p>
                  </div>
                  <v-switch
                    v-model="addeditdata.skipValidations"
                    :true-value="true"
                    :false-value="false"
                    inset
                    dense
                    color="primary"
                    class="mt-0 pt-0 flex-shrink-0"
                    hide-details
                    data-testid="tasklist__add-edit-drawer-skip-validations"
                  />
                </div>
              </v-card>
            </v-col> -->
          </v-row>
          <v-row v-if="customColumns.length" class="all-width align-center justify-center mt-3">
            <v-col v-for="field in customColumns" :key="field.columnName" cols="12" class="my-1 py-1">
              <p class="ma-0 pa-0  text-font-size-md">{{ field.displayText }}</p>
              <!-- Text Field -->
              <lb-string v-if="field.dataType === 'string'" v-model="addeditdata[field.columnName]"
                :label="field.displayText" :error="addeditdataerror[field.columnName]" data-testid="tasklist__add-edit-drawer-custom-field-string" />

              <!-- Date Field -->
              <lb-date v-else-if="field.dataType === 'date'" v-model="addeditdata[field.columnName]"
                :label="field.displayText" :error="addeditdataerror?.[field.columnName]" data-testid="tasklist__add-edit-drawer-custom-field-date" />

              <!-- Number Field -->
              <lb-number v-else-if="field.dataType === 'number'" min="0" :label="field.displayText"
                v-model="addeditdata[field.columnName]" data-testid="tasklist__add-edit-drawer-custom-field-number" />

              <!-- Fallback (optional) -->
              <lb-textBox v-else v-model="addeditdata[field.columnName]" :label="field.displayText" data-testid="tasklist__add-edit-drawer-custom-field-textbox" />
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:actions>
        <v-row class="my-1 px-2 d-flex align-center justify-center">
          <p class="ma-0">*Required</p>
          <v-spacer></v-spacer>
          <v-btn data-testid="tasklist__add-edit-drawer-update-btn" color="primary" v-if="addeditdata._id" class="white--text" @click="addEditItem()"><span>Update</span></v-btn>
          <v-btn data-testid="tasklist__add-edit-drawer-create-btn" color="primary" v-else class="white--text" @click="addEditItem()"><span>Create Task</span></v-btn>
        </v-row>
      </template>
    </lb-drawer>

    <!-- :heading="'Add New '" -->

    <lb-drawer
    v-model="addnewLocation"
    :heading="'Add New ' + (this.$store.state.LocationHeader || 'Location')"
    width="600"
    :loading="addnewLocationloading"
    data-testid="tasklist__add-new-location-drawer"
  >
    <template v-slot:body>
      <div>
        <v-row>
          <v-col cols="12" class="my-0 py-0">
            <p class="ma-0 pa-0  text-font-size-md">Name*</p>
            <lb-string
              v-model="locationdata.name"
              label=""
              placeholder="Enter name "
              :error="locationdataerror.name"
              data-testid="tasklist__add-new-location-drawer-name-input"
            />
          </v-col>

          <v-col cols="12" class="my-0 py-0">
            <p class="ma-0 pa-0  text-font-size-md">Description*</p>
            <lb-string
              v-model="locationdata.description"
              label=""
              placeholder="Enter description"
              :error="locationdataerror.description"
              data-testid="tasklist__add-new-location-drawer-description-input"
            />
          </v-col>

          <v-col cols="12" class="my-0 py-0">
            <p class="ma-0 pa-0  text-font-size-md">Country</p>
            <lb-string
              v-model="locationdata.country"
              label=""
              placeholder="Enter Country"
              :error="locationdataerror.country"
              data-testid="tasklist__add-new-location-drawer-country-input"
            />
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            <p class="ma-0 pa-0  text-font-size-md">Type</p>
            <lb-dropdown
              v-model="locationdata.type"
              :items="locationtypeItem"
              label=""
              placeholder="Enter Type"
              :error="locationdataerror.type"
              itemtext="name"
              itemvalue="value"
              data-testid="tasklist__add-new-location-drawer-type-dropdown"
            />
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  @click="addLocationFun()"
      class="white--text" data-testid="tasklist__add-new-location-drawer-add-btn">
        <span>Add</span>
      </v-btn>
    </template>
    </lb-drawer>

    <lb-drawer v-model="bulkduedatedialog" heading="Edit Due Date" width="500" v-if="bulkduedatedialog" :loading="loading" data-testid="tasklist__bulk-edit-drawer-due-date">
      <template v-slot:body>
        <div class="d-flex align-center">
          <v-chip color="lightpurple" class="caccounting--text d-flex align-center w-30" data-testid="tasklist__bulk-edit-drawer-selected-items-chip">
            <v-icon class="mr-2">mdi-information-outline</v-icon>
            <span>{{selectItem.length}}
            task item selected</span>
          </v-chip>
        </div>
        <p class="mb-1 mt-3 gray--text">Due Days</p>
        <lb-number hidedetails label="" :placeholder="`Enter value between -${$options.MAX_DUE_DATE_DAYS} and ${$options.MAX_DUE_DATE_DAYS}`" v-model="updatebulkduedate" class="mt-2" width="10"  :rules="[v => (Number(v)) <= $options.MAX_DUE_DATE_DAYS || `Number must be ${$options.MAX_DUE_DATE_DAYS} or less`, v => (Number(v)) >= -$options.MAX_DUE_DATE_DAYS || `Number must be -${$options.MAX_DUE_DATE_DAYS} or more`]" data-testid="tasklist__bulk-edit-drawer-due-date-input" />
        <span class="font-size-xs gray--text">Enter the number of days to set the due date automatically based on the cycle ending date.</span>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="" class="black white--text"
          @click="bulkduedateFun(selectItem,updatebulkduedate)" data-testid="tasklist__bulk-edit-drawer-update-btn"><span>Update</span></v-btn>
      </template>
    </lb-drawer>

    <lb-drawer v-model="showNewColumnModal" heading="Add New Column" width="700" v-if="showNewColumnModal" :loading="newColumnModalLoading" data-testid="tasklist__add-new-column-drawer">
      <template v-slot:body>
        <div>
          <v-row>
            <v-col cols="6" class="my-0 py-0">
              <p class="ma-0 pa-0  text-font-size-md">Cycle Type*</p>
              <lb-dropdown label="Select Cycle type" v-model="columnDetails.cycleType"
                :error="columnDetailsError.cycleType" :items="cycleTypes" itemtext="displayText" itemvalue="name" item-class="noTransform" data-testid="tasklist__add-new-column-drawer-cycle-type-dropdown" />
            </v-col>

            <v-col cols="6" class="my-0 py-0">
              <p class="ma-0 pa-0  text-font-size-md">Column Name*</p>
              <lb-string v-model="columnDetails.displayName" label="" placeholder="Enter display name"
                :error="columnDetailsError.displayName" data-testid="tasklist__add-new-column-drawer-column-name-input" />
            </v-col>
            
            <v-col cols="6" class="my-0 py-0">
              <p class="ma-0 pa-0  text-font-size-md">Data Type*</p>
              <lb-dropdown v-model="columnDetails.dataType" :items="columnDataTypes" label=""
                placeholder="Select data type" :error="columnDetailsError.dataType" itemtext="displayText"
                itemvalue="name" item-class="noTransform" data-testid="tasklist__add-new-column-drawer-data-type-dropdown" />
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addNewCustomColumn()" class="white--text" data-testid="tasklist__add-new-column-drawer-add-btn">
          <span>Add</span>
        </v-btn>
      </template>
    </lb-drawer>

    <lb-drawer :Maxwidth="bulkEditFileDataList.length > 0 ? '1665' : '700'" v-model="bulkEditDialog" heading="Bulk Tasklist Edit" :loading="bulkEditDialogloading" data-testid="tasklist__bulk-edit-drawer">
        <template v-slot:body>
            <div>
                <div class="d-flex align-center justify-space-between">
                    <span class="text-center mb-1" v-if="bulkEditFileDataList.length === 0">Upload your document</span>
                    <span v-else>Preview</span>
                    <div class="d-flex gap-2 mb-2">
                        <v-btn text class="secondaryBtn" v-if="bulkEditFileDataList.length > 0" @click="clearfileBulk()" data-testid="tasklist__bulk-edit-drawer-reupload-btn">
                            <v-icon>mdi-reload</v-icon> <span>Re-Upload</span>
                        </v-btn>
                        <v-btn class="secondaryBtn d-flex align-center mb-1" @click="downloadExcelTasklist(selectItem)" data-testid="tasklist__bulk-edit-drawer-download-template-btn"><span>Download Template</span></v-btn>
                    </div>
                </div>
                <div class="d-flex align-center justify-space-between" v-if="bulkEditFileDataList.length > 0 && bulkEditFileDataerror">
                    <v-checkbox  color="caccounting" v-model="showdatawitherrorEditBulk" data-testid="tasklist__bulk-edit-drawer-show-errors-checkbox">
                      <template v-slot:label>
                        <span>Show only items with errors</span>
                      </template>
                    </v-checkbox>
                    <v-spacer></v-spacer>
                </div>
            </div>
            <div class="d-flex align-center justify-center">
                <DragDropfile v-if="bulkEditFileDataList.length === 0" hidedetails :files="bulkEditFileDataFile" @update:files="readBulkEditFile" :resetTrigger="resetbulkEditFile" data-testid="tasklist__bulk-edit-drawer-upload-area" />
            </div>
            <div v-if="bulkEditFileDataList.length > 0" class="radius-small border-on simple-table" style="max-height: 73vh; overflow: auto">
                <v-simple-table data-testid="tasklist__bulk-edit-drawer-preview-table">
                    <template v-slot:default>
                        <thead class="tableHeaderBg">
                            <tr data-testid="tasklist__bulk-edit-drawer-preview-table-header">
                                <th v-for="header in bulkEditTableHeaders" :key="header.value" class="text-center tableHeaderBg">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </thead>
                        <v-slide-y-transition group tag="tbody">
                            <tr v-for="(row, index) in filteredDataEditBluk" :key="'row-' + index">
                                <td v-for="header in bulkEditTableHeaders" :key="'col-' + header.value + '-' + index">
                                    <div v-if="errorsonlyEditBulk[index] && errorsonlyEditBulk[index][header.value]" class="text-error pa-1" style="">
                                        <v-tooltip top color="error" max-width="300">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on" class="d-inline-flex align-center" data-testid="tasklist__bulk-edit-drawer-preview-table-error-icon">
                                                    <v-icon color="error" class="mr-1">mdi-alert-circle</v-icon>
                                                    <span class="error--text font-weight-medium">
                                                        {{ errorsonlyEditBulk[index][header.value] }}
                                                    </span>
                                                </span>
                                            </template>
                                            <span class="d-flex align-center" data-testid="tasklist__bulk-edit-drawer-preview-table-error-tooltip">
                                                <v-icon color="white" class="mr-1">mdi-information</v-icon>
                                                <span>{{ errorsonlyEditBulk[index][header.value] }}</span>
                                            </span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else-if="['tags'].includes(header.value) && Array.isArray(row[header.value])" class="d-flex flex-wrap">
                                        <v-tooltip top v-for="(item, i) in row[header.value]" :key="'tag-' + i">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip v-bind="attrs" v-on="on" class="mr-1 mb-1" outlined :color="header.value === 'tags' ? 'primary' : 'blue'" label data-testid="tasklist__bulk-edit-drawer-preview-table-tag-chip">
                                                    <v-icon left>
                                                        {{ header.value === 'tags' ? 'mdi-tag' : 'mdi-file-link' }}
                                                    </v-icon>
                                                    <span>{{ item }}</span>
                                                </v-chip>
                                            </template>
                                            <span>{{header.value === 'tags' ? 'Tag' : 'Linked GL'}} :{{item}}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else-if="['glcode'].includes(header.value) && Array.isArray(row[header.value])" class="d-flex align-center">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip v-bind="attrs" v-on="on" :color="header.value === 'tags' ? 'primary' : 'blue'" dark>
                                                    <v-icon left>{{ header.value === 'glcode' ? 'mdi-file-multiple' : '' }}</v-icon>
                                                    <span>{{ row[header.value].length }}</span>
                                                </v-chip>
                                            </template>
                                            <div style="max-width: 300px">
                                                <div v-for="(item, i) in row[header.value]" :key="'tooltip-item-'+i" class="d-flex align-center mb-1">
                                                    <v-icon color="white" class="mr-1">{{ header.value === 'glcode' ? 'mdi-file-link' : '' }}</v-icon>
                                                    <span>{{ item }}</span>
                                                </div>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div v-else-if="['preparer', 'approver'].includes(header.value)" class="d-flex flex-wrap">
                                        <v-tooltip top v-for="(name, i) in getNamesByIds(row[header.value])" :key="'name-' + i">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip v-bind="attrs" v-on="on" outlined :color="header.value === 'preparer' ? 'teal' : 'indigo'" class="mr-1 mb-1" label>
                                                    <v-icon left>
                                                        {{ header.value === 'preparer' ? 'mdi-account-edit' : 'mdi-account-check' }}
                                                    </v-icon>
                                                    <span>{{ name }}</span>
                                                </v-chip>
                                            </template>
                                            <span>{{ header.value === 'preparer' ? 'Preparer' : 'Approver' }}: {{ name }}</span>
                                        </v-tooltip>
                                    </div>
                                    <!-- Enhanced Location Display -->
                                    <div v-else-if="['location'].includes(header.value)" class="d-flex flex-wrap">
                                        <v-tooltip top v-for="(name, i) in row[header.value]" :key="'name-' + i">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip v-bind="attrs" v-on="on" outlined color="deep-purple" class="mr-1 mb-1" label>
                                                    <v-icon left>mdi-map-marker</v-icon>
                                                    <span>{{ getLocationById(name) }}</span>
                                                </v-chip>
                                            </template>
                                            <span>Location: {{ getLocationById(name) }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else-if="['task_type'].includes(header.value)">
                                        <span v-if="row[header.value] === LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME">
                                        {{LEGACY_TASK_TYPE_LABEL_CHECKLIST}} Task
                                        </span>
                                        <span v-else>
                                          {{ row[header.value]}}
                                        </span>
                                      </div> 
                                    <!-- Regular Text Display -->
                                    <div v-else class="two-line-clamp">
                                        {{ row[header.value] }}
                                    </div>
                                </td>
                            </tr>
                        </v-slide-y-transition>
                    </template>
                </v-simple-table>
            </div>
            <div v-if="bulkEditErrorResponse && bulkEditErrorResponse.length" class="mt-2">
                <div v-for="(err, idx) in bulkEditErrorResponse" :key="idx" class="error--text font-size-xm">
                    {{idx+1}}.{{ err }}
                </div>
            </div>
            <p v-if="bulkEditFileDataerror" class="error--text ma-0 pa-0 mt-4 font-size-xm"> *These are fields where errors exist / information missing. Please rectify and re-upload to continue. (Preparer & Approver cannot be the same user) </p>
        </template>
        <template v-slot:actions v-if="!bulkEditFileDataerror">
            <v-spacer></v-spacer>
            <div v-if="bulkEditFileDataList.length > 0">
                <v-btn class="ml-2 white--text" color="primary" @click="uploadDataBulk()" data-testid="tasklist__bulk-edit-drawer-upload-button"><span>Upload</span></v-btn>
                <v-btn class="" @click="cleardataBulkEdit()" data-testid="tasklist__bulk-edit-drawer-cancel-button"><span>Cancel</span></v-btn>
            </div>
        </template>
    </lb-drawer>

    <!-- Pagination -->
    <Pagination :list="filteredItemsfromsearch" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="tasklist__pagination" />

  </div>
</template>

<script>
import bulkChecklistUploadV2 from "../../components/BulkUploadChecklistV2/BulkUploadChecklistV2.vue";
import DragDropfile from "../../../../views/Inputs/DragDropfile.vue";
import Pagination from "../../components/Pagination/Pagination.vue";
import CustomizeColumnMenu from "../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue";
import ActivityLog from "../../components/ActivityLog/ActivityLog.vue";
import { getCustomColumns, formatCustomColumns, identifyPossibleTaskTypes, getCustomColumnHeaderText, getTaskTypeOptions, getTaskTypeDisplay } from "../../utils/utils";
import XLSX from "xlsx-color";
import { exportTasklistExcel, attachInactiveLabel, validateDueDays } from "../../utils/tasklistUtils";
import { validateUsersAreActiveAndAttachMessages , activeUserCheckType } from "../../utils/utils";
import { MESSAGES, ACTION_STAGE, ERROR_KEYS_FC_MASTER_TASKLIST,LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME,LEGACY_TASK_TYPE_LABEL_CHECKLIST, MAX_DUE_DATE_DAYS, ACTIVITY_LOG_TYPES } from "../../utils/constants";
export default {
  name: "financialclose_master_checklist",
  // Expose constant for template interpolation via $options
  MAX_DUE_DATE_DAYS,
  ACTIVITY_LOG_TYPES,
  data: function () {
    return {
      right: "financialclose_master_checklist",
      clientID:this.$store.state.client,
      possibleassertions: this.$constants.TASK_LIST_CONSTANTS.ASSERTIONS,
      // Raw backend task types kept for validation; UI should use taskTypes (mapped display values)
      possibleTaskTypes: Object.values(this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES),
      // Centralized task type options with display mapping (e.g., Normal Task -> Checklist)
      taskTypes: getTaskTypeOptions(),
      LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME,
      LEGACY_TASK_TYPE_LABEL_CHECKLIST,
      addeditdata: {},
      addeditdataerror: {},
      addeditdialog: false,
      addeditloading: false,
      loading: false,
      hasActiveTableFilter: false,
      id:this.$store.state.client,
      formdata: {},
      userlist: {},
      listdata: [],
      bulkactionuserdialog: false,
      bulkduedatedialog:false,
      updatebulkduedate:'',
      expectedHeaders: this.$constants.EXPECTED_HEADERS_MASTER,
      multiselectdata: [],
      bulkactionuserselected: false,
      isLocation:false,
      bulkactionuserusertype: "",
      bulkactionuserid: "",
      menuOpen: false,
      bulkuploadstatus:false,
      headers: [
        {
          value: "ref",
          text: "Ref",
          visible: true,
          filterable: true,
          sortable: true,

        },
        {
          value: "description",
          text: "Description",
          visible: true,
          filterable: true,
          sortable: false,

        },
        {
          value: "task_type",
          text: "Task type",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "category",
          text: "Category",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "subcategory",
          text: "Sub category",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "assertionscount",
          text: "Assertions",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          value: "location",
          text: this.$store.state.LocationHeader|| 'Location',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "duedays",
          text: "Due days",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "priority",
          text: "Priority",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "purpose",
          text: "Purpose",
          visible: true,
          filterable: true,
          sortable: false,
        },
        {
          value: "instruction",
          text: "Instruction",
          visible: true,
          filterable: true,
          sortable: false,
        },
        {
          value: "tags",
          text: "Tags",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "no_of_evidence",
          text: "No. of Evidences",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "created_at",
          text: "Created on",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          value: "preparer",
          text: "Preparer",
          visible: true,
          filterable: true,
          sortable: false,
        },
        {
          value: "approver",
          text: "Approver",
          visible: true,
          filterable: true,
          sortable: false,
        },
        {
          value: "action",
          text: "Action",
          visible: true,
          sticky: true,
        },

      ],
      formatedData: [],
      formatedDataCopy:[],
      customColumns:[],
      cycleType:"FBC",
      cycleTypes:[
        {
          displayText:"FBC",
          name:"FBC"
        },
        {
          displayText:"RM",
          name:"RM"
        },
        {
          displayText:"IA",
          name:"IA"
        },
        {
          displayText:"Others",
          name:"OTHERS"
        },
      ],
      columnDetails:{
        cycleType:'',
        columnName:'',
        displayName:'',
        dataType:''
      },
      columnDetailsError:{},
      isNewColumnModalLoading:false,
      showNewColumnModal:false,
      newColumnModalLoading:false,
      columnDataTypes:[
        {
          name:"string",
          displayText:"Text"
        },
        {
          name:"date",
          displayText:"Date"
        },
        {
          name:"number",
          displayText:"Number"
        },
      ],
      possibleusers: [],
      bulkactionuserloading: false,
      selectaction: "add",
      changetouser: "",
      itemapprover: [
        { value: "associate", name: "Add" },
        { value: "remove", name: "Remove" },
        { value: "replace", name: "Replace" },
        { value: "move", name: "Change to Approver" },
      ],
      itempreparer: [
        { value: "associate", name: "Add" },
        { value: "remove", name: "Remove" },
        { value: "replace", name: "Replace" },
        { value: "move", name: "Change to Preparer" },
      ],
      activitylogconfig: {
        userassociate: {
          icon: "mdi-plus",
          color: "info",
          displaytext: "User Associated",
        },
        userreplaced: {
          icon: "mdi-account-convert",
          color: "info",
          displaytext: "User Replaced",
        },
        userremoved: {
          icon: "mdi-close",
          color: "error",
          displaytext: "User Removed",
        },
        usermoved: { icon: "mdi-sync", color: "", displaytext: "Updated" },
        tasklistupdated: {
          icon: "mdi-pencil",
          color: "primary",
          displaytext: "Updated",
        },
      },
      search: "",
      searchcolumn: "",
      searchlocation: "",
      searchusername: "",
      viewchecklistdialog: false,
      viewchecklistdata: {},
      userid: "",
      addnewLocation: false,
      addnewLocationloading: false,
      locationdialog: false,
      locationdialogloading: false,
      location_details: [],
      users_details: [],
      adduserdialog: false,
      addApprover: [],
      addPrepares: [],
      addLocation: [],
      copyaddLocation:[],
      locationAddIds: [], // Stores selected IDs
      locationRemoveIds: [],
      locationUserList: [],
      locationdata: {},
      locationdataerror: {},
      addLocationerr: {},
      subcategoryAcc: [],
      categoryAcc: [],
      coaCategoryAcc: [],
      coaSubcategoryAcc: [],
      possibleGlCodes: [],
      locationBasedGl: [],
      addUsersAppPer: false,
      addpreparerusers: [],
      addapproverusers: [],
      typeAppPer: '',
      addAppPerLoa: '',
      itemsPerPage: 50,
      storeTotal: '',
      selectAll: false,
      selectItem: [],
      customassertions: [],
      locationtypeItem: [],
      tab: '',
      sorting: false,
      menu: false,
      Alltags: ["Yearly", "Half-yearly", "Monthly"],
      locationUserDropdown: 0,
      visibleRowsitems: 6,
      bulkActionStage: 0,
      bulkManageSkipValidation: false,
      locationUserSkipValidation: false,
      activityLogById: [],
      showMore: false,
      showAll: false,
      priorityList: ["High", "Medium", "Low"],
      selectedFilterItems: [],
      searchfilters: '',
      fixedDivHeight: 0,
      paginatedFilteredItems:[],
      activitylogLoading:false,
      e13: 1,
      bulkEditDialog:false,
      bulkEditDialogloading:false,
      bulkEditFileDataFile:null,
      resetbulkEditFile:false,
      bulkEditFileDataList: [],
      bulkEditFileDataerror: false, 
      showdatawitherrorEditBulk:false,
      bulkEditTableHeaders: [...this.$constants.TASK_LIST_CONSTANTS.BULK_EDIT_HEADERS_MASTER],
      errorsonlyEditBulk:[],
      bulkEditErrorResponse:[],
      tableFilterHeader: {}, // Will store the selected filter values
      page_name: 'financialclose_master_checklist', // Unique identifier for the page,
      userDetails:{ activeUsers: [], activeUserIds: [] },
      customizeMenuOpen: false
    };
  },
  created() {
    this.init();
    this.processCOAData();
    this.getActiveUsers();
  },
  activated() {
    this.init();
  },
  components: {
    bulkChecklistUploadV2, Pagination, DragDropfile, CustomizeColumnMenu, ActivityLog,
  },
  computed: {
    additionalLocations(){
       return item => Array.isArray(item.location) ? item.location.slice(1) : [];
    },
    /**
     * True if at least one selected task is Account Reconciliation type.
     * Used to conditionally show the Threshold Enforcement step (stage 4).
     */
    bulkSelectionHasReconTasks() {
      const AR = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
      return this.selectItem.some(item => item.task_type === AR);
    },
    isEditingReconTask() {
      return this.addeditdata.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    },
    filteredDataEditBluk() {
      if (this.showdatawitherrorEditBulk) {
        return this.bulkEditFileDataList.filter((_, rowIndex) =>
          Object.values(this.dataerroreditBulk[rowIndex]).some((error) => error)
        );
      }
      return this.bulkEditFileDataList; // Return all rows if not filtering errors
    },
    
    displayedLocations() {
      return this.showAll ? this.viewchecklistdata.locationlist : this.viewchecklistdata.locationlist.slice(0, 6);
    },
    filteredUniqueLocations() {
      const locationIds = new Set(this.locationUserList.map(item => item.location_id));
      const filteredLocationDetails = this.location_details.filter(
        location => !locationIds.has(location._id)
      );

      return filteredLocationDetails;
    },

    filteredItemsfromsearch() {
      let filteredData = this.formatedData.filter(item =>
        item.description.toLowerCase().includes(this.search.toLowerCase())
      );

      if (this.selectedFilterItems.length > 0) {
        filteredData = filteredData.filter(item => {
          return this.selectedFilterItems.every(filter => {
            return Object.entries(filter).every(([key, values]) => {
              const itemValue = item[key];
              return Array.isArray(itemValue)
                ? itemValue.some(val => values.includes(val))
                : values.includes(itemValue);
            });
          });
        });
      }

      return filteredData;
    },
    filteredHeaders() {
      const searchTerm = this.searchcolumn.toLowerCase();
      return this.headers.filter(header =>
        header.text.toLowerCase()?.includes(searchTerm)
      );
    },
    filteredlocation() {
      const searchTerm = this.searchlocation.toLowerCase();
      return this.location_details.filter(location =>
        location.name.toLowerCase()?.includes(searchTerm)
      );
    },
    filteredActiveUsers() {
      const searchTerm = this.searchusername?.toLowerCase() ?? "";
      const activeUserIdSet = new Set(this.userDetails?.activeUserIds);
      const activeUsers = this.formdata.users.filter(
      user =>
        activeUserIdSet.has(user?._id) &&
        user?.name?.toLowerCase().includes(searchTerm)
      );
      let users;
      // For Tasklist Edit , check preparer and approver to check for inactive users
       if (this.addeditdata?._id) {
        users = [...this.addeditdata.preparer, ...this.addeditdata.approver];
      }
      else if (this.bulkActionStage === ACTION_STAGE.ADD_PREPARERS) {
        users = this.addPrepares.map(_id => ({ _id }));
      } else if (this.bulkActionStage === ACTION_STAGE.ADD_APPROVERS) {
        users = this.addApprover.map(_id => ({ _id }));
      } else {
        users = [...this.formdata.users] || [];
      }
      // For Adding new task, show only active users
      if (this.locationUserDropdown === 1 || this.locationUserDropdown === 2) {
      return activeUsers;
      }
      if (this.addeditdata._id || this.bulkActionStage === ACTION_STAGE.ADD_PREPARERS || this.bulkActionStage === ACTION_STAGE.ADD_APPROVERS) {
      // Edit mode: show all, label inactive
      const hasInactive = users?.some(user => !activeUserIdSet.has(user._id));
      if (hasInactive) {
      return attachInactiveLabel(this.formdata.users, this.userDetails.activeUserIds)
        .filter(user => user.name.toLowerCase().includes(searchTerm));
      }
     }
      // New task: only active users
      return activeUsers;
    },
    allowedTaskTypes() {
      return identifyPossibleTaskTypes(this.addeditdata?._id, this.addeditdata?.task_type);
    }
  },
  
  methods: {
    /**
     * Handler for filter-active-change event from DataTableAction
     */
    onFilterActiveChange(isActive) {
      this.hasActiveTableFilter = isActive;
    },
    /**
     * Clear table filters via DataTableAction ref
     */
    clearTableFilter() {
      if (this.$refs.dataTableAction) {
        this.$refs.dataTableAction.clearFilter();
      }
    },
     hasLocation(item) {
      return Array.isArray(item.location) && item.location.length > 0;
    },
  togglePreparer(id) {
      const idx = this.addPrepares.indexOf(id);
      if (idx === -1) this.addPrepares.push(id);
      else this.addPrepares.splice(idx, 1);
    },
    toggleApprover(id) {
      const idx = this.addApprover.indexOf(id);
      if (idx === -1) this.addApprover.push(id);
      else this.addApprover.splice(idx, 1);
    },
    onEvidenceInput(val) {
      if (typeof val !== 'number') val = Number(val);
      if (val < 0 || val > 10) {
        this.addeditdataerror.no_of_evidence = ['Please enter a value between 0 and 10.'];
      } else {
        this.addeditdataerror.no_of_evidence = '';
      }
      this.addeditdata.no_of_evidence = val;
    },
    validateDueDayInput(val) {
      const error = validateDueDays(val, MAX_DUE_DATE_DAYS);
      this.$set(this.addeditdataerror, 'duedays', error);
    },
 
    getCanonicalTagKey(tag) {
      if (tag === null || tag === undefined) return '';
      const normalized = String(tag).trim().replace(/\s+/g, ' ').toLowerCase();
      return normalized;
    },
    normalizeTagLabel(tag) {
      if (tag === null || tag === undefined) return '';
      const normalized = String(tag).trim();
      if (!normalized) return '';
      return normalized;
    },
    normalizeAndDedupeTags(tags) {
      if (!Array.isArray(tags)) return [];

      // Build canonical key → existing list value map from Alltags
      const masterTagMap = new Map();
      if (Array.isArray(this.Alltags)) {
        this.Alltags.forEach(masterTag => {
          const key = this.getCanonicalTagKey(masterTag);
          if (key) masterTagMap.set(key, masterTag);
        });
      }

      // Dedupe: if user input matches an existing tag (case-insensitive), use the list value
      const seenKeys = new Set();
      const dedupedTags = [];

      tags.forEach((tag) => {
        const normalizedTag = this.normalizeTagLabel(tag);
        if (!normalizedTag) return;

        const canonicalKey = this.getCanonicalTagKey(normalizedTag);
        if (seenKeys.has(canonicalKey)) return; // Skip duplicate

        seenKeys.add(canonicalKey);
        // If matched in list, use stored form; otherwise keep user input as-is
        dedupedTags.push(masterTagMap.has(canonicalKey) ? masterTagMap.get(canonicalKey) : normalizedTag);
      });

      return dedupedTags;
    },
    syncAllTagsFromListData() {
      const tagsFromData = (this.listdata || []).flatMap(item => Array.isArray(item.tags) ? item.tags : []);
      this.Alltags = this.normalizeAndDedupeTags([...(this.Alltags || []), ...tagsFromData]);
    },
    areTagArraysEqual(arrA = [], arrB = []) {
      if (arrA.length !== arrB.length) return false;
      return arrA.every((tag, index) => tag === arrB[index]);
    },
    getColumnValue(column, task) {
    if (column.dataType === "date") {
      return task[column.columnName]
        ? this.$nova.formatDate(task[column.columnName])
        : "";
    }
    return task[column.columnName] || "";
  },
    goToStep(stepNumber) {
      this.step = stepNumber;
    },
    updateValue(newVal) {
      this.bulkuploadstatus = newVal;
    },
    setPaginatedData(paginationInfo) {
      if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
        this.paginatedFilteredItems = paginationInfo.data || [];
        this.page = paginationInfo.page || 1;
      } else {
        this.paginatedFilteredItems = paginationInfo || [];
      }
    },
    addPreparerToLocation(item) {
      this.addPrepares = [...this.addPrepares, item._id]
    },
    addApproverToLocation(item) {
      this.addApprover = [...this.addApprover, item._id]
    },
    async getActiveUsers(){
      try{
        await this.$store.dispatch("tasks/getAllUsersWithStatus",{isActiveUsersRequired:true})
        this.$set(this.userDetails, 'activeUsers', this.$store.getters["tasks/getActiveUsersList"] || []);
        this.$set(this.userDetails, 'activeUserIds', this.$store.getters["tasks/getActiveUsersIds"] || []);
      }catch(error){
        console.error("Error fetching users:", error);
        this.$store.commit("sbError", MESSAGES.FAILED_TO_GET_USERS);
        this.$set(this.userDetails, 'activeUsers', []);
        this.$set(this.userDetails, 'activeUserIds', []);
      }
    },
    getlocationNamebyId(id) {
      if (typeof id === 'object' && id !== null) {
        id = id._id;
      }
      const name = (this.location_details || []).find(
        (loc) => loc._id === id
      );

      return name ? name.name : "";
    },

    ActivityLogData(id) {
      this.activitylogLoading=true
      return this.axios
        .post("/v2/financialclose/masters/checklist/getlogs/" + id)
        .then((dt) => {
          this.listdata = [];
          if (dt.data.status === "success") {
            this.activityLogById = dt.data.data
          } else throw new Error(dt.data.message);
          this.activitylogLoading=false
        })
    },

    resetStage() {
      this.selectedFilterItems = [];
      this.tableFilterHeader = {};
      this.formatedData = this.formatedDataCopy.slice();
    },
    getItemData(item, key) {
      return item[key];
    },
    showMoreRows() {
      this.visibleRowsitems += this.locationUserList.length - 6;
    },
    showLessRows() {
      this.visibleRowsitems = 6;
    },
    nextStepforLocation(stage) {
      this.locationUserDropdown = stage
    },
    select(isSelected) {
      if(isSelected){
        // Select all items across all pages
        this.selectItem = [...this.filteredItemsfromsearch]
      }
      else
      {
        this.selectItem=[]
      }
    },
    resetTaskForm() {
      // Reset all form fields to default values
      this.addeditdata = {
        _id: null,
        title: '',
        description: '',
        status: 'active',
        // Reset all other fields to default values
        preparer: [],
        approver: [],
        location: [],
        dueDate: null,
        customFields: {}
      };
      
      // Reset any selection arrays or UI state variables
      this.addLocation = [];
      this.addPrepares = [];
      this.addApprover = [];
      this.locationUserList = [];
      this.locationUserDropdown = 0;
      this.selectedCategory = null;
      this.selectedPriority = null;
      
      // Reset any validation errors
      this.errors = {};
      this.formValid = true;
      
      // Reset any file uploads or any other complex fields
      this.attachments = [];
      this.uploadedFiles = [];
      
      // Reset any other custom state variables related to the task form
      //this.customColumns = {};
      this.menu = false;
    },
    removeAllSelect() {
      if (this.selectItem.length === this.formatedData.length) this.selectAll = true;
      else this.selectAll = false;
    },
    addTableHeader(item) {
      this.headers.find((x) => x === item ? x.visible = !x.visible : "")
    },

    /**
     * Handle Apply button click from CustomizeColumnMenu
     * Updates column visibility locally (session only)
     * @param {Array} headers - Updated headers array
     */
    handleApplyColumns(headers) {
      this.headers = headers;
      this.customizeMenuOpen = false;
    },

    /**
     * Sync body cell order when columns are reordered via drag-and-drop
     * @param {Array} headers - Reordered headers from DataTableAction
     */
    onColumnReorder(reorderedHeaders) {
      this.headers.splice(0, this.headers.length, ...reorderedHeaders);
    },

    /**
     * Handle Save Columns button click from CustomizeColumnMenu
     * Persists column preferences to database using Vuex saveCustomLayout action
     * @param {Object} payload - { headers, pageName }
     */
    async handleSaveColumns({ headers, pageName }) {
      console.log('[Manage/Tasklist]: Saving columns for', pageName, headers);
      this.headers = headers;
      this.loading = true;
      try {
        await this.$store.dispatch('saveCustomLayout', {
          axios: this.axios,
          page: pageName || this.page_name,
          cycleId: this.id,
          layout: headers,
          filter: this.tableFilterHeader || {}
        });
        // Update page_details with new layout for consistency
        this.page_details = { cycle_id: this.id, pagename: this.page_name, layout: headers };
        this.customizeMenuOpen = false;
      } catch (err) {
        console.error('[Manage/Tasklist]: Error saving columns:', err);
      } finally {
        this.customizeMenuOpen = false;
        this.loading = false;
      }
    },

    onCycleTypeChange() {
    this.getData();
  },
  async saveHeaderText(header) {
    try {
      // Validate the header text
      if (!header.value || header.value.trim() === "") {
        this.$store.commit("sbError", "Header text cannot be empty.");
        return;
      }
      const columnName = header.value
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
      // Prepare the payload for the API call
      const payload = {
        data: {
          columnName: columnName,
          displayName: header.value.trim(),
        },
        query: {
          _id: header._id,
          cycle_type: this.cycleType.toUpperCase(),
        },
      };

      // Make the API call to update the header text
      const response = await this.axios.post(
        "/v2/financialclose/masters/checklist/editColumn/",
        payload
      );

      if (response?.data?.status === "success") {
        // Update the local headers array
        const headerIndex = this.headers.findIndex((h) => h._id === header._id);
        if (headerIndex !== -1) {
          this.headers[headerIndex].text = header.text.trim();
          this.headers[headerIndex].isEditing = false;
          
        }

        this.$store.commit("sbSuccess", "Header text updated successfully.");
      } else {
        throw new Error(response?.data?.message || "Failed to update header text.");
      }
    } catch (error) {
      console.error("Error saving header text:", error);
      this.$store.commit("sbError", error.message || "An unexpected error occurred.");
    }
  },
  // Function to toggle the editing state of a header
  toggleEditHeader(header) {
    // Toggle the `isEditing` property of the header
    header.isEditing = !header.isEditing;

    // If entering edit mode, store the original text for potential rollback
    if (header.isEditing) {
      header.originalText = header.text;
    } else {
      // If exiting edit mode without saving, revert to the original text
      header.text = header.originalText || header.text;
    }
  },
    formateData() {
      let ObjectTemp = {};
      let ArrayTemp = [];
      this.listdata.forEach((item, index) => {
        ObjectTemp = {
          __key: index,
          __formatedkey: index,
          _id: item._id,
          indexno: index + 1,
          ref: item.ref,
          category: item.category,
          subcategory: item.subcategory,
          duedays: item.duedays,
          assertionscount: item.assertions.length,
          assertions: item.assertions,
          location: this.getLocationNamesOnly(item.location),
          locationlist: item.location,
          description: item.description,
          approver: this.nameReturn(item.approver),
          approverids: item.approver,
          preparer: this.nameReturn(item.preparer),
          preparerids: item.preparer,
          priority:item.priority,
          tags: this.normalizeAndDedupeTags(item.tags),
          no_of_evidence: item.no_of_evidence || 0,
          slno: item.slno,
          glcode: item.glcode,
          instruction: item.instruction,
          purpose: item.purpose,
          created_at: item.created_at.split('T')[0],
          updated_at: item.updated_at,
          status: item.status,
          cycle_type: item.cycle_type,
          // Display label via centralized helper
          task_type: getTaskTypeDisplay(item.task_type),
          skipValidations: item.skipValidations != null
            ? !!item.skipValidations
            : !!(Array.isArray(item.location) && item.location.length > 0 && item.location[0]?.skipValidations),
        };
        // Dynamically add custom columns
        this.customColumns.forEach(field => {
          const key = field.columnName;
          if (!(key in ObjectTemp)) {
            ObjectTemp[key] = item[key] ?? '';
          }
        });

        ArrayTemp.push(ObjectTemp);
      });
      this.formatedData = this.$nova.filterByDynamicCriteria(
        ArrayTemp,
        this.tableFilterHeader
      );
      this.formatedDataCopy = ArrayTemp;
      if(ArrayTemp.length === 0){
        this.readColumns()
      }
      
      this.pagecount = Math.ceil(this.storeTotal / this.itemsPerPage);

    },
    async addNewCustomColumn() {
      const { displayName, dataType, cycleType } = this.columnDetails;
      // Check if all required fields are filled
      const isEmpty = val =>
        val === null ||
        val === undefined ||
        (typeof val === "string" && val.trim() === "") ||
        (Array.isArray(val) && val.length === 0);

      // Validate input fields
      this.columnDetailsError = {
        displayName: isEmpty(displayName) ? "Please enter display name" : "",
        dataType: isEmpty(dataType) ? "Please select data type" : "",
        cycleType: isEmpty(cycleType) ? "Please select cycle type" : "",
      };

      // Check for duplicate column name
      const isDuplicate = this.headers.some(header =>
        typeof header.text === "string" &&
        header.text.trim().toLowerCase() === String(displayName).trim().toLowerCase()
      );

      if (isDuplicate) {
        this.columnDetailsError.displayName = "Custom column name already exists";
        return;
      }

      // If any validation error exists
      const hasError = Object.values(this.columnDetailsError).some(Boolean);
      if (hasError) {
        this.$store.commit("sbError", "Please fill all the required fields");
        return;
      }

      this.newColumnModalLoading = true;

      try {
        // Generate column name (e.g., "My Column" → "my_column")
        const columnName = displayName
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "_")
          .replace(/^_+|_+$/g, "");

        this.columnDetails.columnName = columnName;
        this.columnDetails.cycleType = cycleType.toUpperCase();

        // POST API call to create the column
        const response = await this.axios.post(
          "/v2/financialclose/masters/checklist/createColumn",
          { columnDetails: this.columnDetails }
        );

        if (response?.data?.status === "success") {
          await this.getData();
          this.$store.commit("sbSuccess", "Custom column added successfully");

          // Reset form
          this.columnDetails = {
            displayName: "",
            dataType: "",
            cycleType: ""
          };
          this.columnDetailsError = {};
          this.showNewColumnModal = false;
        } else {
          throw new Error(response?.data?.message || "Unknown error occurred");
        }
      } catch (err) {
        console.error("Error at addNewCustomColumn:", err);
        this.$store.commit("sbError", err.message || "Failed to add custom column");
      } finally {
        this.newColumnModalLoading = false;
      }
    },
    async deleteCustomColumn(columnDetails) {
  try {
    const { value, _id } = columnDetails;
    if (!value) {
      this.$store.commit("sbError", "Missing column. Cannot delete.");
      return;
    }

    // Optional: Confirm before deletion
    const confirmDelete = confirm(`Are you sure you want to delete column "${value}"?`);
    if (!confirmDelete) return;

    // Construct the delete payload (soft delete)
    const payload = {
      data: { deleted: true },  // mark column as deleted
      query: { _id: _id, cycle_type:this.cycleType.toUpperCase() }         // target column by _id
    };

    // Call backend API
    const response = await this.axios.post(`/v2/financialclose/masters/checklist/editColumn/`, payload);

    if (response?.data?.status === "success") {
      this.refreshData();
      this.$store.commit("sbSuccess", `Column "${value}" deleted successfully.`);
    } else {
      throw new Error(response?.data?.message || "Failed to delete column.");
    }

  } catch (err) {
    console.error("Error at deleteCustomColumn:", err);
    this.$store.commit("sbError", err.message || "An unexpected error occurred.");
  }
},

async editCustomColumn(columnDetails) {
  try {
    const { value, _id, columnName, displayName } = columnDetails;

    if (!value) {
      this.$store.commit("sbError", "Missing column. Cannot delete.");
      return;
    }

    // Optional: Confirm before deletion
    const confirmDelete = confirm(`Are you sure you want to edit column "${value}"?`);
    if (!confirmDelete) return;
    // Construct the delete payload (soft delete)


    const payload = {
      data: { columnName: columnName,
        displayName: displayName },  // mark column as deleted
      query: { _id: _id, cycle_type:this.cycleType.toUpperCase() }         // target column by _id
    };

    // Call backend API
    const response = await this.axios.post(`/v2/financialclose/masters/checklist/editColumn/`, payload);

    if (response?.data?.status === "success") {
      this.refreshData();
      this.$store.commit("sbSuccess", `Column "${value}" edited successfully.`);
    } else {
      throw new Error(response?.data?.message || "Failed to edit column.");
    }

  } catch (err) {
    console.error("Error at deleteCustomColumn:", err);
    this.$store.commit("sbError", err.message || "An unexpected error occurred.");
  }
},

    // MARKER: TASK_TYPE
    exportToCsv() {
      const baseHeaders = [
        'Reference',
        'TaskType',
        'Description',
        'Category',
        'Subcategory',
        'Assertions',
        'Location',
        'DueDays',
        'Purpose',
        'Instruction',
        'Tags',
        'Created_at',
        'Approver',
        'Preparer',
        'No. of Evidences',
        'GLCode',
      ];
      // Add custom headers from customColumns
      const customHeaders = this.customColumns.map(col => col.displayText);
      const headers = [...baseHeaders, ...customHeaders];

      const data = this.formatedData.map(item => {
        const row = {
        Reference: item.ref,
        TaskType: item.task_type,
        Description: item.description,
        Category: item.category,
        Subcategory: item.subcategory,
        Assertions: Array.isArray(item.assertions) ? item.assertions.join(', ') : item.assertions,
        Location: Array.isArray(item.location) ? item.location.join(', ') : item.location,
        DueDays: item.duedays,
        Purpose: item.purpose,
        Instruction: item.instruction,
        Tags: Array.isArray(item.tags) ? item.tags.join(', ') : item.tags,
        Created_at: item.created_at,
        Approver: Array.isArray(item.approver) ? item.approver.join(', ') : item.approver,
        Preparer: Array.isArray(item.preparer) ? item.preparer.join(', ') : item.preparer,
        Evidences: item.no_of_evidence || 0,
        GLCode: Array.isArray(item.glcode) ? item.glcode.join(', ') : item.glcode,
      }
        // Add custom columns
        this.customColumns.forEach(col => {
          row[col.displayText] = item[col.columnName] || '';
        });
        return row;
      }
    );
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data, { header: headers });
      headers.forEach((header, index) => {
        const cell_address = XLSX.utils.encode_cell({ c: index, r: 0 });
        if (!ws[cell_address]) return;
        ws[cell_address].s = {
          font: {
            bold: true,
            color: { rgb: "FFFFFF" }
          },
          fill: {
            fgColor: { rgb: "black" }
          }
        };
      });
      ws['!cols'] = headers.map((header) => {
        if (header === 'Description') {
          return { wch: 40 };
        }
        return { wch: 20 };
      });
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'Tasklist-master.xlsx');
    },

    init() {
      this.refreshData();
    },
    refreshData() {
      this.charts = [];
      this.chartdata = {};
      this.listdata = [];
      this.userid = this.$store.state.user.id;
      this.getData();
      this.viewchecklistdialog = false;
    },
    // viewChecklist(item) {
    //   this.addeditdialog = false;
    //   this.viewchecklistdialog = false;
    //   this.viewchecklistdata = item;
    //   let newGlCode = this.chartAcc.filter(item => {
    //     if (this.viewchecklistdata.glcode?.includes(item.glcode)) {
    //       return item
    //     }
    //   });
    //   this.viewchecklistdata.glcode = newGlCode
    //   this.viewchecklistdialog = true;
    // },
    viewChecklist(item) {
      this.addeditdialog = false;
      this.viewchecklistdialog = false;
      // Ensure glcode is initialized as an array
      const glcodeList = Array.isArray(item.glcode) ? item.glcode : [];
      // Filter only matching GL codes from chartAcc
      const newGlCode = this.chartAcc.filter(acc => glcodeList.includes(acc.glcode));
      // Assign full object with updated glcode
      this.viewchecklistdata = {
        ...item,
        glcode: newGlCode
      };
      this.viewchecklistdialog = true;
    },
    async getData() {
  this.loading = true;
  try {
    let customColumns = {};
    // 1. Call checklist form data API
    let formDataResponse = await this.axios.post("/v2/financialclose/masters/checklist/getformdata");
    await this.getCustomColumns();
    if (formDataResponse?.data?.status === "success") {
      this.formdata = formDataResponse.data.data[0] || {};
      this.location_details = this.formdata.location;
      this.users_details = this.formdata.users;
      this.userlist = {};
      let colors = this.$nova.getColors((this.formdata.users || []).length, 0.2);

      (this.formdata.users || []).forEach((el, i) => {
        this.userlist[el._id] = { ...el, color: colors[i] };
      });
    } else {
      throw new Error(formDataResponse.data.message);
    }

    // 2. Call location form selects API
    let locationResponse = await this.axios.post("/v2/financialclose/location/formselects");
    if (locationResponse?.data?.status === "success") {
      this.locationtypeItem = locationResponse.data.data[0]?.type || "";
    }

    // 3. Chart of accounts
    let chartResponse = await this.axios.post("/v2/financialclose/masters/chartofaccount/get");
    if (chartResponse?.data?.status === "success") {
      this.chartAcc = chartResponse.data.data;
      this.coaCategoryAcc = [...new Set((this.chartAcc || []).map(x => x.category).filter(Boolean))];
      this.coaSubcategoryAcc = [...new Set((this.chartAcc || []).map(y => y.subcategory).filter(Boolean))];
      this.glcodeAcc = this.chartAcc.map(z => z.glcode);
      this.processCOAData();
    }

    // 4. Checklist get API with cycle type
    let checklistResponse = await this.axios.post(
      "/v2/financialclose/masters/checklist/get",
      { query: { cycle_type: this.cycleType.toUpperCase() } }
    );

    if (checklistResponse?.data?.status === "success") {
      this.listdata = (checklistResponse.data.data || []).map(item => {
        if (Array.isArray(item.customfields)) {
          const flatCustomFields = Object.assign({}, ...item.customfields);
          if (!Object.keys(customColumns).length) {
            customColumns = { ...flatCustomFields };
          }

          const itemWithoutCustomFields = { ...item };
          return { ...itemWithoutCustomFields, ...flatCustomFields };
        }
        return item;
      });

      // Extract unique assertions (preserve any existing this.possibleassertions order first, then new ones, then ensure 'Others')
      const uniqueAssertions = new Set();
      const existing = Array.isArray(this.possibleassertions) ? this.possibleassertions : [];
      existing.forEach(a => uniqueAssertions.add(a));
      this.listdata.forEach(item => {
        (item.assertions || []).forEach(assertion => uniqueAssertions.add(assertion));
      });
      uniqueAssertions.add('Others');
      this.possibleassertions = Array.from(uniqueAssertions);

      // Fetch non-AR category/subcategory values via backend endpoint and merge with COA
      await this.fetchAndMergeMasterCategories();
    } else {
      throw new Error(checklistResponse.data.message);
    }

    // 5. Process custom columns
    const formattedCustomColumns = await this.getCustomColumnsByCycleType();
    if (formattedCustomColumns && formattedCustomColumns.length > 0) {
      this.customColumns = formattedCustomColumns;

      // Initialize addeditdata for each custom column
      this.customColumns.forEach(field => {
        this.addeditdata[field.columnName] = '';
      });

      // Prepare headers with custom flag
      // Preserve saved visibility from existing headers if available
      const customHeaders = formattedCustomColumns.map(header => {
        const columnName = header.columnName;
        // Check if this custom column already exists in headers (from saved layout)
        const existingHeader = this.headers.find(
          h => h.value === columnName || h.value_en === `custom_${columnName}`
        );
        // Preserve the saved visibility if it exists, otherwise default to true
        const savedVisibility = existingHeader?.visible !== undefined ? existingHeader.visible : true;
        
        return {
          value_en: `custom_${columnName}`,
          value: columnName,
          text: header.displayText,
          visible: savedVisibility,
          filterable: true,
          sortable: true
        };
      });
      

      // 🧹 Clean existing custom headers
      this.headers = this.headers.filter(h => !String(h.value_en).startsWith("custom_"));

      // 🔁 Insert before the last item if length allows, else just append
      const headersLength = this.headers.length;
      if (headersLength >= 2 && customHeaders.length > 0) {
        this.headers = [
          ...this.headers.slice(0, headersLength - 1),
          ...customHeaders,
          ...this.headers.slice(headersLength - 1),
        ];
      } else {
        this.headers = [...this.headers, ...customHeaders];
      }
    } else {
      this.customColumns = [];
      this.headers = this.headers.filter(h => !String(h.value_en).startsWith("custom_"));

    }
    this.page_details = { cycle_id: this.id, pagename: this.page_name, layout: this.headers};
    this.formateData();
    this.syncAllTagsFromListData();
  } catch (error) {
    this.$store.commit("sbError", error.message || "Unknown error!");
  } finally {
    this.loading = false;
    this.resetTaskForm()
  }
},
async getCustomColumns(){
      const layoutData = await this.$store.dispatch('tasks/fetchCustomLayout', { pageName: this.page_name });
      try {
        if (layoutData?.custom_layout && Array.isArray(layoutData?.custom_layout) && layoutData?.custom_layout.length > 0) {
          this.headers = layoutData.custom_layout;
          // Validate filter keys against current headers before applying
          const rawFilter = layoutData.filter?.[this.id] || {};
          this.tableFilterHeader = this._validateFilterKeys(rawFilter);
        } else {
          this.headers = JSON.parse(JSON.stringify(this.defaultTableHeadersfilter));
          this.tableFilterHeader = JSON.parse(JSON.stringify(this.defaultTableFilterHeader));
        }
      } catch (error) {
        console.error("[Manage/Tasklist] Error fetching custom columns:", error);
      }
    },
    /**
     * Validates filter keys against current table headers to remove stale/invalid filter entries.
     * This prevents API errors when filter columns have been deleted from the system.
     * @param {Object} filter - The filter object to validate
     * @returns {Object} - Cleaned filter with only valid keys
     */
    _validateFilterKeys(filter) {
      if (!filter || typeof filter !== 'object') return {};
      
      // Get valid header values from headers
      const validHeaderValues = new Set();
      const headersToCheck = this.headers || [];
      headersToCheck.forEach(h => {
        if (h && h.value) validHeaderValues.add(h.value);
        if (h && h.value_en) validHeaderValues.add(h.value_en);
      });
      
      // If no headers yet (component initializing), return filter as-is
      if (validHeaderValues.size === 0) return filter;
      
      // Clean filter by removing keys that don't match any header
      const cleanedFilter = {};
      
      Object.keys(filter).forEach(filterKey => {
        if (validHeaderValues.has(filterKey)) {
          cleanedFilter[filterKey] = filter[filterKey];
        } else {
          console.warn(`[Manage/Tasklist] Removed stale filter key: ${filterKey}`);
        }
      });
      
      return cleanedFilter;
    },
    async getCustomColumnsByCycleType() {
      try {
        const customColumnsResponse = await this.axios.post('/v2/financialclose/masters/checklist/readColumn/',{query:{cycle_type:this.cycleType.toUpperCase(), deleted: false}});
          if (customColumnsResponse?.data?.status === 'success' && Array.isArray(customColumnsResponse?.data?.data) && customColumnsResponse?.data?.data.length > 0) {
           return formatCustomColumns(customColumnsResponse?.data?.data);
          }else{
           return []
          }
      } catch (err) {
        this.$store.commit("sbError", err?.message || err || "Failed to get custom columns by cycle type");
        console.error("Error fetching custom columns by cycle type:", err);
      }
        return [];
    },
    /**
     * Fetches distinct non-AR category/subcategory values from all master tasks
     * of the same cycle_type and merges them with COA lists into categoryAcc/subcategoryAcc.
     * Always resets to COA base before merging to prevent stale values from other cycle types.
     * @param {string} [cycleTypeOverride] - Optional cycle type to use instead of this.cycleType
     */
    async fetchAndMergeMasterCategories(cycleTypeOverride) {
      const { categoryAcc, subcategoryAcc } = await this.$store.dispatch('tasks/fetchMasterCategories', {
        cycleType: cycleTypeOverride || this.cycleType,
        coaCategoryAcc: this.coaCategoryAcc,
        coaSubcategoryAcc: this.coaSubcategoryAcc,
      });
      this.categoryAcc = categoryAcc;
      this.subcategoryAcc = subcategoryAcc;
    },
    processCOAData() {
      this.location_details.forEach((location, index) => {
        this.locationBasedGl[location._id] = []
        for (const glItem of this.chartAcc) {
          for (const gllocation of (glItem.location || [])) {
            if (location._id === gllocation._id) {
              this.locationBasedGl[location._id].push(glItem)
            }
            if (index === this.location_details.length - 1) {
              this.setLocationBasedGL(this.locationBasedGl)
            }
          }
        }

      });
    },
    setLocationBasedGL(data) {
      this.locationBasedGl = data;
    },

    addEditForm(dt = {}) {
      this.viewchecklistdialog = false;
      this.locationUserList = dt.locationlist || [];
      this.addeditdata = {
        ...dt,
        tags: this.normalizeAndDedupeTags(dt.tags)
      };
      // Normalize task_type to internal value if a display label was provided
      if (this.addeditdata && this.addeditdata.task_type) {
        const match = Array.isArray(this.taskTypes)
          ? this.taskTypes.find(t => t && (t.name === this.addeditdata.task_type || t.value === this.addeditdata.task_type))
          : null;
        if (match) this.addeditdata.task_type = match.value;
      }
      this.addeditdataerror = {};
      this.addeditdialog = true;
    },
    // Unified validation (mirrors Project/Tasklist.vue with adjustments for locationUserList structure)
    validateTaskFields() {
      this.addeditdataerror = {};
      // Use descriptive variable names instead of single-letter aliases
      const taskData = this.addeditdata || {};
      const validationErrors = this.addeditdataerror;
      const setRequiredError = (key, msg = 'required') => { validationErrors[key] = [msg]; };

      // Core required fields
      const EM = this.$constants.TASK_LIST_CONSTANTS.ERROR_MESSAGES;
      if (!taskData.description || !String(taskData.description).trim()) setRequiredError('description', EM.TASK_DESCRIPTION_REQUIRED);
      if (!taskData.category) setRequiredError('category', EM.CATEGORY_REQUIRED);
      if (!taskData.subcategory) setRequiredError('subcategory', EM.SUBCATEGORY_REQUIRED);
      if (!taskData.task_type) setRequiredError('task_type', EM.TASK_TYPE_REQUIRED);
      if (!taskData.tags || !Array.isArray(taskData.tags) || taskData.tags.length === 0) setRequiredError('tags', EM.TAG_REQUIRED);
      if (!taskData.cycle_type) setRequiredError('cycle_type', EM.CYCLE_TYPE_REQUIRED);
      if (!taskData.priority || taskData.priority.length === 0) setRequiredError('priority', EM.PRIORITY_REQUIRED);

      // Location / users group sourced from locationUserList (each item: {location_id, preparer:[], approver:[]})
      const locList = Array.isArray(this.locationUserList) ? this.locationUserList : [];
      const allPreparers = locList.flatMap(l => Array.isArray(l.preparer) ? l.preparer : []).filter(Boolean);
      const allApprovers = locList.flatMap(l => Array.isArray(l.approver) ? l.approver : []).filter(Boolean);
      if (!locList.length) setRequiredError('location_users', EM.LOCATION_REQUIRED);
      if (!allPreparers.length) setRequiredError('location_users', EM.PREPARER_REQUIRED);
      if (!allApprovers.length) setRequiredError('location_users', EM.APPROVER_REQUIRED);

      // Overlap check
      if (allPreparers.length && allApprovers.length) {
        const overlap = allPreparers.filter(x => allApprovers.includes(x));
      if (overlap.length) setRequiredError('location_users', EM.PREPARER_APPROVER_OVERLAP);
      }

      // Custom required columns
      if (Array.isArray(this.customColumns)) {
        this.customColumns.forEach(col => {
          if (col.isRequired && (taskData[col.columnName] === undefined || taskData[col.columnName] === null || taskData[col.columnName] === '')) {
            setRequiredError(col.columnName, `${col.displayText} is required`);
          }
        });
      }

      // Due Days validation: must be between -200 and 200
      if (taskData.duedays !== null && taskData.duedays !== undefined && taskData.duedays !== '') {
        const duedayStr = String(taskData.duedays).trim();
        // Check for invalid patterns like "0-0", "0-300", "1-2" etc.
        const hasInvalidPattern = /^\d+-\d+$/.test(duedayStr) || /[^\d-]/.test(duedayStr.replace(/^-/, ''));
        // Check if it's a valid integer (allows negative sign at start)
        const isValidNumber = /^-?\d+$/.test(duedayStr);
        
        if (!isValidNumber || hasInvalidPattern) {
          // Contains non-numeric characters or invalid pattern
          if (/[a-zA-Z]/.test(duedayStr)) {
            setRequiredError('duedays', 'Please provide a number values');
          } else {
            setRequiredError('duedays', 'Please give correct validated values');
          }
        } else {
          const dueday = Number(duedayStr);
          if (dueday < -MAX_DUE_DATE_DAYS || dueday > MAX_DUE_DATE_DAYS) {
            setRequiredError('duedays', `Enter value between -${MAX_DUE_DATE_DAYS} and ${MAX_DUE_DATE_DAYS}`);
          }
        }
      }

      // GL validation tied to task_type using selectgls (selected GL ids / objects) or existing d.glcode
      const TASK_TYPES = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES;
      const glSelected = (this.selectgls && this.selectgls.length) || (Array.isArray(taskData.glcode) && taskData.glcode.length);
      if (taskData.task_type === TASK_TYPES?.ACCOUNT_RECONCILIATION) {
        if (!glSelected) setRequiredError('glcode', EM.ACCOUNT_NO_REQUIRED || EM.ACCOUNT_NO_REQUIRED);
        // AR COA membership check
        if (taskData.category && !this.coaCategoryAcc.includes(taskData.category)) {
          setRequiredError('category', EM.CATEGORY_NOT_FROM_COA);
        }
        if (taskData.subcategory && !this.coaSubcategoryAcc.includes(taskData.subcategory)) {
          setRequiredError('subcategory', EM.SUBCATEGORY_NOT_FROM_COA);
        }
      } else if (taskData.task_type === TASK_TYPES?.NORMAL) {
        if (glSelected) setRequiredError('glcode', EM.ACCOUNT_NO_NOT_ALLOWED_NORMAL);
      }

      return Object.keys(this.addeditdataerror).length === 0;
    },
    // MARKER: TASK_TYPE
    addEditItem() {
      this.addeditloading = true;
      this.addeditdata.tags = this.normalizeAndDedupeTags(this.addeditdata.tags);
      this.Alltags = this.normalizeAndDedupeTags([...(this.Alltags || []), ...(this.addeditdata.tags || [])]);
      // Run unified validation first
      if (!this.validateTaskFields()) {
        this.$store.commit('sbError', 'Please fill all mandatory fields');
        this.addeditloading = false;
        return;
      }
      let type = "add";
      // Validate active users in preparerids and approverids
      this.addeditdata.location = this.locationUserList;
      if(!this.validateUsersAreActive()) {
        this.addeditloading = false;
        return;
      }
      let url = "/v2/financialclose/masters/checklist/add";
      if (this.addeditdata._id) {
        type = "edit";
        url =
          "/v2/financialclose/masters/checklist/edit/" + this.addeditdata._id;
      }
      this.addeditdata.assertions = this.addeditdata.assertions && this.addeditdata.assertions.filter(item => item !== "Others");
      if (this.customassertions) {
        const customassertion = this.addeditdata.customassertions.split(',').map(item => item.trim()) || {};
        this.possibleassertions = [...new Set([...customassertion, ...this.possibleassertions])];
        this.addeditdata.assertions = [...new Set([...customassertion, ...this.addeditdata.assertions])];
      }
      let customfields = [];
      if (this.customColumns.length > 0) {
        customfields = this.customColumns.map((column) => ({
          [column.columnName]: this.addeditdata[column.columnName] !== undefined ? this.addeditdata[column.columnName] : column.dataType === 'number' ? 0 : '',
        }));
      }
      this.addeditdata.customfields = customfields

      //------------------
      const updateToastr = () => {
        this.$store.commit(
            "sbError",
            this.addeditdataerror || "Unknown error!"
          );
      }
      // Task type / GL already validated; safeguard
      if (!Object.values(this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES).includes(this.addeditdata.task_type)) {
        this.addeditdataerror.task_type = ['required'];
        updateToastr();
        this.addeditloading = false;
        return;
      }
      //------------------

      //this.addeditdata.cycle_type
      let ndt = { ...this.addeditdata };
      if (!ndt.glcode) {
        ndt.glcode = this.selectgls;
      }
      // Normalize glcode based on task type: empty for NORMAL tasks
      if (ndt.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
        ndt.glcode = [];
      }
      delete ndt._id;
      this.axios
        .post(url, { data: ndt })
        .then((dt) => {
          if (dt.data.status === "success") {
            if (type === "add")
              this.$store.commit("sbSuccess", "Checklist item added");
            else this.$store.commit("sbSuccess", "Checklist item updated");
            this.addeditdialog = false;
            this.locationUserList = [];
            this.refreshData();
          } else {
            if (dt.data.data.length > 0) {
                this.$store.commit("sbError", dt.data.message || "Checklist item added/updated with errors");
              if (dt.data.data[0].index0)
                this.addeditdataerror = dt.data.data[0].index0;
              if (this.addeditdataerror.tags) {
                throw new Error("Tags required");
              } else if (this.addeditdataerror.location) {
                throw new Error("Location required");
              }
            } else throw new Error(dt.data.message);
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.addeditloading = false;
        });
    },
    validateUsersAreActive() {
      const { valid, messages } = validateUsersAreActiveAndAttachMessages(
        this.addeditdata,
        this.userDetails.activeUsers,
        this.formdata.users,
        activeUserCheckType.TASKLIST
      );
      if (!valid && messages.length) {
        this.$store.commit('sbError', messages.join(' '));
      }
      return valid;
    },
    enableDisableAccess(id, action) {
      this.loading = true;
      let url = "/v2/financialclose/masters/checklist/disable/";
      if (action === "enable") {
        url = "/v2/financialclose/masters/checklist/enable/";
      }
      this.axios
        .post(url + id, {})
        .then((dt) => {
          if (dt.data.status === "success") {
            if (action === "enable") {
              this.$store.commit("sbSuccess", "Item enabled");
              // this.listdata[k].status = true;
            } else {
              this.$store.commit("sbSuccess", "Item disabled");
              // this.listdata[k].status = false;
            }
            this.refreshData();
          } else throw new Error(dt.data.message || "Error performing action");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    bulkActionDuedilog(selectitems){
      console.log(selectitems);
      this.bulkduedatedialog = true;
      this.updatebulkduedate = "";
    },
    bulkEditTask(){
      this.bulkEditDialog = true;
      this.bulkEditFileDataList = [];
      this.bulkEditFileDataerror = false;
      this.bulkEditFileDataFile = null;
      this.resetbulkEditFile = false;
      this.bulkEditDialogloading = false;
      this.bulkEditErrorResponse = [];
    },
      // MARKER: TASK_TYPE
     downloadExcelTasklist(selectedItem) {
      const selectIds = selectedItem.map(item => item._id);
      const selectedTaskItems = this.formatedDataCopy.filter(item => selectIds.includes(item._id));

      exportTasklistExcel({
      title: "Tasklist List",
      filename: "Tasklist.xlsx",
      sheetName: "TOP SHEET",
      taskItems: selectedTaskItems,
      // ✅ Columns defined here
      columns: [
          { header: { v: "Reference", s: { font: { bold: true } } }, value: "ref" },
          { header: { v: "Task Description", s: { font: { bold: true } } }, value: "description" },
          { header: { v: "Due Days", s: { font: { bold: true } } }, value: "duedays" },
          { header: { v: "Category", s: { font: { bold: true } } }, value: "category" },
          { header: { v: "Sub Category", s: { font: { bold: true } } }, value: "subcategory" },
          { header: { v: "Priority", s: { font: { bold: true } } }, value: "priority" },
          {
            header: { v: "Preparer", s: { font: { bold: true } } },
            value: task => this.getEmailByIdsBulk(task.preparerids),
          },
          {
            header: { v: "Approver", s: { font: { bold: true } } },
            value: task => this.getEmailByIdsBulk(task.approverids),
          },
          {
            header: { v: "Purpose", s: { font: { bold: true } } },
            value: task => task.purpose || "",
          },
          {
            header: { v: "Instruction", s: { font: { bold: true } } },
            value: task => task.instruction || "",
          },
          {
            header: { v: "Tags", s: { font: { bold: true } } },
            value: task => task.tags?.join(", ") || "",
          },
          {
            header: { v: "No. of Evidences", s: { font: { bold: true } } },
            value: task => task.no_of_evidence || 0,
          },
          {
            header: { v: "Account No", s: { font: { bold: true } } },
            value: task => task.glcode?.join(", ") || "",
          },
          {
            header: { v: "Location", s: { font: { bold: true } } },
            value: task => task.location?.join(", ") || "",
          },
          {
            header: { v: "Skip Validation", s: { font: { bold: true } } },
            value: task => task.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION
              ? (task.skipValidations ? "Yes" : "No")
              : "N/A",
          },
           ... this.customColumns.length ? this.customColumns.map(column => ({
            header: {
             v: getCustomColumnHeaderText(column),
              s: { font: { bold: true } }
            },
            value: task => this.getColumnValue(column, task),
          }))
        : []
        //   ...this.customColumns.length ? this.customColumns.map(column => ({
        //   header: { v: column.displayText, s: { font: { bold: true } } },
        //   value: task => task[column.columnName] || "",
        // })) : []
         ]
       });
      },
     getEmailByIdsBulk(ids) {
             if (!Array.isArray(ids)) return "";
             return ids.map((id) => {
                     const user = this.users_details.find((x) => x._id === id);
                     return user ? user.email : "";
                 }).filter(Boolean) // remove empty names
                 .join(", ");
         },
         clearfileBulk() {
             this.resetbulkEditFile = !this.resetbulkEditFile;
             this.bulkEditFileDataList = [];
             this.bulkEditFileDataerror = false;
             this.dataerroreditBulk = [];
             this.errorsonlyEditBulk = [];
             this.bulkEditErrorResponse = [];
         },
         getLocationById(id) {
             let locationname = this.location_details.find(
                 (location) => location._id === id);
             return locationname ? locationname.name : "";
         },
         getLocationByIdsBulk(name) {
             if (!Array.isArray(name)) return "";
             return name.map((name) => {
                     const location = this.location_details.find((x) => x.name === name);
                     return location ? location.name : "";
                 }).filter(Boolean) // remove empty names
                 .join(", ");
         },

          // Validates date strings in dd/mm/yyyy format with leap year support
          validateDDMMYYYY(value) {
            // Expected format: dd/mm/yyyy (day and month can be 1 or 2 digits)
            if (typeof value !== 'string') return { valid: false, date: null };

            const trimmed = value.trim();
            if (!trimmed) return { valid: false, date: null };

            // Match dd/mm/yyyy allowing leading zeros or single digits
            const match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (!match) return { valid: false, date: null };

            let [, dd, mm, yyyy] = match;
            const day = parseInt(dd, 10);
            const month = parseInt(mm, 10);
            const year = parseInt(yyyy, 10);

            if (year < 1000 || year > 9999) return { valid: false, date: null };
            if (month < 1 || month > 12) return { valid: false, date: null };
            if (day < 1) return { valid: false, date: null };

            const monthLengths = [31, ( (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0) ) ? 29 : 28,
                                  31, 30, 31, 30,
                                  31, 31, 30, 31, 30, 31];

            if (day > monthLengths[month - 1]) return { valid: false, date: null };

            // Construct date in UTC to avoid timezone shifts
            const dateObj = new Date(Date.UTC(year, month - 1, day));

            // Final sanity check
            if (isNaN(dateObj.getTime())) return { valid: false, date: null };

            return { valid: true, date: dateObj };
          },
      // MARKER: TASK_TYPE
    readBulkEditFile(files) {
      const bulkeditFile = files[0];
      if (!bulkeditFile || !bulkeditFile.name) return;
      const headings = ["Reference", "Task Description", "Due Days", "Category", "Sub Category", "Priority", "Preparer", "Approver", "Purpose", "Instruction", "Tags", "No. of Evidences", "Account No", "Location", "Skip Validation"];
      // if (this.customColumns.length) {
      //     headings.push(...this.customColumns.map(column => column.displayText));
      // }
       if (this.customColumns.length) {
        headings.push(...this.customColumns.map(column =>
          column.dataType === "date"
            ? `${column.displayText} (dd/mm/yyyy)`
            : column.displayText
        ));
      }
      this.bulkEditTableHeaders = [...this.$constants.TASK_LIST_CONSTANTS.BULK_EDIT_HEADERS_MASTER];
      this.bulkEditTableHeaders.push({ text: "Skip Validation", value: "skipValidations" });
      this.bulkEditTableHeaders.push(...this.customColumns.map(column => ({
          text: column.displayText,
          value: column.columnName,
      })));
      this.bulkEditDialogloading = true;
      const ext = bulkeditFile.name.split(".").pop();
      Promise.resolve().then(() => {
          if (!["xlsx", "xls", "xlsm", "xlsb"].includes(ext)) {
              throw new Error("Only xlsx, xls, xlsm, xlsb file extensions supported");
          }
          return this.$nova.readExcelFile(bulkeditFile, "");
      }).then(async (dt) => {
          const cleanedDt = dt.map(row => {
              if (!Object.prototype.hasOwnProperty.call(row, 0) || row[0] === null || row[0] === "") {
                  return row.slice(1); // Remove the first element
              }
              return row;
          });
          this.bulkEditFileDataerror = false;
          if (JSON.stringify(cleanedDt[1] || []) !== JSON.stringify(headings)) {
              throw new Error(`Columns '${headings.join("','")}' are required in the same order`);
          }
          const filedata = [];
          const errordata = [];
          // Precompute COA Sets once for all AR row validations in the loop
          const coaCategorySet = this.chartAcc.length > 0 ? new Set(this.chartAcc.map(acc => acc.category).filter(Boolean)) : null;
          const coaSubcategorySet = this.chartAcc.length > 0 ? new Set(this.chartAcc.map(acc => acc.subcategory).filter(Boolean)) : null;
          for (let i = 2; i < cleanedDt.length; i++) {
              if (cleanedDt[i].length === 0) continue;
            const [ref, description, duedays, category, subcategory, priority, preparerName, approverName, purpose, instruction, tagss, evidences, linkedgls, locationNames, skipValidationValue] = cleanedDt[i];
            const matchedTask = this.formatedDataCopy.find(x => x.ref === ref);
            if (!matchedTask) {
              this.$store.commit("sbError", `Reference '${ref}' not found in tasklist`);
              continue;
            }
            const preparerNames = preparerName?.split(',').map(n => n.trim()).filter(Boolean) || [];
            const approverNames = approverName?.split(',').map(n => n.trim()).filter(Boolean) || [];
            const tags = tagss?.split(',').map(n => n.trim()).filter(Boolean) || [];
            // Parse evidences explicitly. Preserve 0 and allow blank -> use existing value; invalid -> mark error later.
            let no_of_evidence;
            if (evidences === undefined || evidences === null || evidences === "") {
              // keep original or default 0
              no_of_evidence = (matchedTask.no_of_evidence === undefined || matchedTask.no_of_evidence === null) ? 0 : Number(matchedTask.no_of_evidence);
            } else if (!isNaN(Number(evidences)) && Number(evidences) >= 0) {
              no_of_evidence = Number(evidences);
            } else {
              no_of_evidence = NaN; // trigger validation error below
            }
            const linkedgl = linkedgls?.toString().split(',').map(n => n.trim()).filter(Boolean) || [];
            const duplicateUsers = preparerNames.filter(email => approverNames.includes(email));
            // Normalize location input (can be number like 1000 or comma separated string)
            const locationName = (locationNames == null ? '' : locationNames.toString())
              .split(',')
              .map(n => n.trim())
              .filter(Boolean);
            const matchedLocation = this.location_details
              .filter(loc => {
                const name = (loc.name || '').trim();
                return locationName.includes(name) || locationName.includes(loc._id);
              })
              .map(loc => loc._id);
            const matchedPreparers = preparerNames.map(email => {
              const user = this.users_details.find(u => u.email?.trim() === email);
              return user ? user._id : email;
            });
            const matchedApprovers = approverNames.map(email => {
              const user = this.users_details.find(u => u.email?.trim() === email);
              return user ? user._id : email;
            });
            const matchedGls = linkedgl.map(glcode => {
              const user = this.chartAcc.find(u => String(u.glcode || '').trim() === String(glcode || '').trim());
              return user ? user.glcode : glcode;
            });
            let rowdata = {
              task_type: "",
              ref,
              description,
              duedays,
              category,
              subcategory,
              priority,
              preparer: matchedPreparers,
              approver: matchedApprovers,
              purpose: purpose || "",
              instruction: instruction || "",
              tags,
              // Store actual evidences numeric value; also provide 'evidences' alias for table header mapping
              no_of_evidence,
              evidences: no_of_evidence,
              location: matchedLocation,
              _id: matchedTask._id,
              glcode: matchedGls,
              skipValidations: (skipValidationValue?.toString().toLowerCase() === 'yes'),
            };
            rowdata.task_type = rowdata.glcode.length ? this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION : this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
              const errors = {
                preparer:'',
                approver:'',
                glcode:'',
                location:''
              };
              let customfields = [];
              if (this.customColumns.length > 0) {
                  customfields = this.customColumns.map((column) => {
                   let displayText =  column.dataType === "date"
            ? `${column.displayText} (dd/mm/yyyy)`
            : column.displayText;
                      const value = cleanedDt[i][headings.indexOf(displayText)];
                      let fieldValue = value || ''; // Default field value
                      const errorKey = column.columnName;
                      // Validate custom fields and add errors for mismatched data types
                      if (value && column.dataType === 'number' && isNaN(Number(value))) {
                          errors[errorKey] = `'${value}' is not a valid number`;
                      }
                      if (column.dataType === 'date') {
                      if (!value) {
                        fieldValue = ''; // allow empty
                      } else if (value instanceof Date) {
                        fieldValue = value.toISOString();
                      } else if (typeof value === 'string') {
                        const { valid, date } = this.validateDDMMYYYY(value);
                        if (!valid) {
                          errors[errorKey] = `'${value}' is not a valid date (expected dd/mm/yyyy)`;
                        } else {
                          fieldValue = date.toISOString();
                        }
                      } else {
                        errors[errorKey] = `'${value}' is not a valid date (expected dd/mm/yyyy)`;
                      }
                    }
                      return {
                          [column.columnName]: fieldValue
                      };
                  });
                  rowdata = {
                      ...rowdata,
                      ...customfields.reduce((acc, field) => ({
                          ...acc,
                          ...field
                      }), {})
                  };
              }
              rowdata.customfields = customfields;
              if (!description) errors["description"] = "Description is required";
                if (!description) errors["description"] = "Description is required";
              if (duedays === null || duedays === undefined || duedays === "") {
                errors["duedays"] = "Due Days is required";
              } else if (isNaN(Number(duedays))) {
                errors["duedays"] = "Due Days must be a valid number";
              } else if (Number(duedays) < -MAX_DUE_DATE_DAYS || Number(duedays) > MAX_DUE_DATE_DAYS) {
                errors["duedays"] = `Due Days must be between -${MAX_DUE_DATE_DAYS} and ${MAX_DUE_DATE_DAYS}`;
              }
              if (!category) errors["category"] = "Category is required";
              if (!subcategory) errors["subcategory"] = "Subcategory is required";
              // Category & Sub Category COA validation for AR tasks
              if (rowdata.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION && coaCategorySet) {
                if (category && !coaCategorySet.has(category)) {
                  errors["category"] = this.$constants.TASK_LIST_CONSTANTS.ERROR_MESSAGES.CATEGORY_NOT_FROM_COA;
                }
                if (subcategory && !coaSubcategorySet.has(subcategory)) {
                  errors["subcategory"] = this.$constants.TASK_LIST_CONSTANTS.ERROR_MESSAGES.SUBCATEGORY_NOT_FROM_COA;
                }
              }
              if (!priority) errors["priority"] = "Priority is required";
              if (!Array.isArray(tags) || tags.length === 0) {
                  errors["tags"] = "Tags is required";
              }
              if (no_of_evidence === null || no_of_evidence === undefined || isNaN(no_of_evidence)) {
                errors["evidences"] = "Invalid evidences (must be a number >= 0)";
              }
              const isRecon = rowdata.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
              const isNormal = rowdata.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
              // Validation rules:
              //  - Account Reconciliation: Account No is required (must have at least one GL code)
              //  - Normal: Account No must NOT be provided
              if (isRecon && (!Array.isArray(matchedGls) || matchedGls.length === 0)) {
                errors["glcode"] = "Account No is required";
              }
              if (isNormal && Array.isArray(matchedGls) && matchedGls.length > 0) {
                errors["glcode"] = "Account No not allowed for Normal task";
              }
              if (!preparerName) errors["preparer"] = "Preparer is required";
              if (!approverName) errors["approver"] = "Approver is required";
              if (!locationNames) errors["location"] = "Location is required";
              if (duplicateUsers.length > 0) {
                  errors["preparer"] += `Preparer and Approver cannot be the same: ${duplicateUsers.join(", ")}`;
              }
              for (const name of preparerNames) {
                  const matched = this.users_details.find(u => u.email?.trim() === name);
                  if (!matched) {
                      errors["preparer"] += `Invalid Preparer: '${name}' not found`;
                  }
              }
              for (const name of approverNames) {
                  const matched = this.users_details.find(u => u.email?.trim() === name);
                  if (!matched) {
                      errors["approver"] += `Invalid Approver: '${name}' not found`;
                  }
              }
              const activeUserEmails = (this.userDetails.activeUsers || []).map(user => user.email) ?? [];
              // Check for inactive preparers and approvers
              const inactivePreparer = preparerNames.filter(email => !activeUserEmails.includes(email));
              const inactiveApprover = approverNames.filter(email => !activeUserEmails.includes(email));
              if (inactivePreparer.length > 0) {
                  errors["preparer"] += `Inactive Preparer(s): ${inactivePreparer.join(", ")}`;
              }
              if (inactiveApprover.length > 0) {
                  errors["approver"] += `Inactive Approver(s): ${inactiveApprover.join(", ")}`;
              }
              for (const location of locationName) {
                const matched = this.location_details.find(u => (u.name || '').trim() === location || u._id === location);
                if (!matched) {
                  errors["location"] += `Invalid Location: '${location}' not found`;
                }
              }
              for (const code of matchedGls) {
                  const matched = this.chartAcc.find(u => String(u.glcode || '').trim() === String(code || '').trim());
                  if (!matched) {
                      errors["glcode"] += `Invalid GL Code: '${code}' not found`;
                  }
              }
              for (const location of matchedLocation) {
                  const glCodes = this.locationBasedGl[location._id]?.map(item => item.glcode);
                  if (glCodes) {
                      const invalidGlCodes = matchedGls.filter(gl => !glCodes.includes(gl));
                      if (invalidGlCodes.length > 0) {
                          errors["glcode"] += `Invalid GL Code(s) for location '${location.name}': ${invalidGlCodes.join(", ")}`;
                      }
                  }
              }
              const errorKeys = ERROR_KEYS_FC_MASTER_TASKLIST || [];
              const hasError = errorKeys.some(key => errors[key]);
              if (hasError) {
                  rowdata.error = Object.values(errors).filter(Boolean).join(" | ");
                  this.bulkEditFileDataerror = true;
                  this.flageditBulk = true;
              }
              filedata.push(rowdata);
              errordata.push(errors);
          }
          this.bulkEditFileDataList = filedata;
          this.dataerroreditBulk = errordata;
          this.errorsonlyEditBulk = this.dataerroreditBulk;
      }).catch((err) => {
          console.log(err);
          this.$store.commit("sbError", err.message || err || "Unknown error!");
      }).finally(() => {
          this.bulkEditFileDataFile = null;
          this.bulkEditDialogloading = false;
      });
  },
	getNamesByIds(ids) {
		// If empty, null, or not array, convert to array
		if (!Array.isArray(ids)) {
			if (typeof ids === 'string') {
				ids = [ids]; // single ID string
			} else if (ids == null) {
				return []; // null or undefined
			} else {
				return [String(ids)]; // fallback case
			}
		}

		return ids
			.map((id) => {
				const user = this.users_details.find((u) => u._id === id);
				return user ? user.name : id; // fallback to showing the ID if name not found
			})
			.filter(Boolean);
	},
  // MARKER: TASK_TYPE
	uploadDataBulk() {
		this.bulkEditDialogloading = true;
		const url = "/v2/financialclose/masters/checklist/bulkUpdateMasterTaskList";
		const transformed = this.bulkEditFileDataList.map(item => {
			const location = item.location.map(locId => ({
				location_id: locId,
				preparer: item.preparer,
				approver: item.approver,
				skipValidations: !!item.skipValidations,
			}));

			return {
				...item,
				location
			};
		});
		this.axios
			.post(url, {
				data: transformed
			})
			.then((dt) => {
				if (dt.data.status === "success") {
					this.bulkEditDialog = false;
					this.$store.commit("sbSuccess", "Checklist uploaded successfully");
					this.refreshData();
				} else {
          this.bulkEditErrorResponse = dt.data.data || [];
          throw dt.data.message || "Error uploading Tasklist";
          }
			})
			.catch((err) => {
				this.$store.commit("sbError", err.message || err || "Unknown error!");
				this.resetbulkEditFile = !this.resetbulkEditFile;
        console.log(err);
			})
			.finally(() => {
				// this.resetbulkEditFile = !this.resetbulkEditFile;
				this.bulkEditDialogloading = false;
				this.bulkEditFileDataList = [];
				this.showdatawitherrorEditBulk = false;
				this.dataerroreditBulk = [];
				this.errorsonlyEditBulk = [];
        this.bulkEditTableHeaders = [...this.$constants.TASK_LIST_CONSTANTS.BULK_EDIT_HEADERS_MASTER];
			});

	},
	cleardataBulkEdit() {
		this.bulkEditFileDataList = [];
		this.bulkEditFileDataerror = false;
		this.dataerroreditBulk = [];
		this.errorsonlyEditBulk = [];
		this.bulkEditDialog = false;
		this.bulkEditDialogloading = false;
	},
    bulkduedateFun(selecteditem,date){
            // Validate Due Days range before making API call
            const dueDaysNum = Number(date);
            if (isNaN(dueDaysNum) || dueDaysNum < -MAX_DUE_DATE_DAYS || dueDaysNum > MAX_DUE_DATE_DAYS) {
                this.$store.commit('sbError', `Due Days must be between -${MAX_DUE_DATE_DAYS} and ${MAX_DUE_DATE_DAYS}`);
                return;
            }
            this.loading = true;
            let fdt = { duedays:date,_id: selecteditem.map(item => item._id) };
            let url = "/v2/financialclose/masters/checklist/bulkupdateduedays";
            this.axios.post(url, { data: fdt }).then(dt => {
                if (dt.data.status === "success") {
                    this.$store.commit("sbSuccess", dt.data.message || "Due days updated successfully");
                    this.bulkduedatedialog = false;
                    this.refreshData();
                } else throw Error(dt.data.message || "Unknown error")
            }).catch(err => {
                this.$store.commit("sbError", err.message || err || "Unknown error!");
                console.log(err);
            }).finally(() => {
                this.loading = false;
            })
            
        },
    nameReturn(ids) {
      let arrayTem = [];
      for (const id of ids) {
        arrayTem.push(this.userlist[id]);
      }
      let newarray = arrayTem.map((i) => i?.name)
      return newarray;
    },
    getLocationName(locationId) {
      const location = this.location_details.find(
        (loc) => loc._id === locationId
      );
      return location ? location.name : "base";
    },
    getPreparesName(id) {
      const location = (this.formdata.users || []).find(
        (loc) => loc._id === id
      );
      return location ? location.name : "Unknown";
    },
    getApproversName(id) {
      const location = (this.formdata.users || []).find(
        (loc) => loc._id === id
      );
      return location ? location.name : "Unknown";
    },

    addUserLocation(locationlist, preparer, approve, skipValidations = false) {
      if (locationlist.length === 0 || preparer.length === 0 || approve.length === 0) {
        this.$store.commit("sbError", "locations, preparers, and approves must not be empty");
        return; // Do not proceed if any of them is empty
      }
      locationlist.forEach(locationId => {
        const existingLocationIndex = this.locationUserList.findIndex(userLocation => userLocation.location_id === locationId);

        if (existingLocationIndex !== -1) {
          // If the location exists, update the preparer and approver values
          this.locationUserList[existingLocationIndex].preparer = Array.from(new Set([...this.locationUserList[existingLocationIndex].preparer, ...preparer]));
          this.locationUserList[existingLocationIndex].approver = Array.from(new Set([...this.locationUserList[existingLocationIndex].approver, ...approve]));
          this.$set(this.locationUserList[existingLocationIndex], 'skipValidations', !!skipValidations);
        } else {
          // If the location doesn't exist, push a new entry
          const obj = {
            location_id: locationId._id,
            preparer: [...new Set(preparer)],
            approver: [...new Set(approve)],
            skipValidations: !!skipValidations,
          };
          this.locationUserList.push(obj);
        }
      });
      // Apply skip validations to the task being edited
      this.$set(this.addeditdata, 'skipValidations', !!skipValidations);
      this.locationUserSkipValidation = false;
      this.adduserdialog = false;
      this.menu = false;
      this.locationUserDropdown = 0;
      this.addApprover = [];
      this.addPrepares = [];
      this.addLocation = [];
    },

    bulklocationChange(locations, approvers, preparers, ids, skipValidations) {
      this.addLocationerr = {};
      if (
         locations.length === 0 &&
        approvers.length === 0 &&
        preparers.length === 0
      ) {
         const arrays = ["locations", "approvers", "preparers"];

        arrays.forEach((array) => {
          this.addLocationerr[array] = "required";
        });
      } else {
        let data = {
          approver: approvers,
          preparer: preparers,
          location: locations,
          skipValidations: skipValidations,
        };
        this.loading = true;
        this.axios
          .post("/v2/financialclose/masters/checklist/managelocation", {
            data: data,
            filter: { _id: ids.map((x) => x._id) },
          })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.$store.commit(
                "sbSuccess",
                "location users add successfully"
              );
              this.getData();
              this.locationdialog = false;
              this.bulkActionStage = 0;
              this.addLocation = [];
              this.addApprover = [];
              this.addPrepares = [];
              this.selectItem = [];
              this.bulkManageSkipValidation = false;
            } else {
              this.addLocationerr = {};
              if (ele.data.data.length > 0) {
                if (ele.data.data[0].index0)
                  this.addLocationerr = ele.data.data[0].index0;
              } else
                throw new Error(ele.data.message || "Error adding location");
            }
          })
          .catch((err) => {
            this.$store.commit(
              "sbError",
              err.message || err || "Unknown error!"
            );
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    loactioncheck(selectedLocations, id) {
    if (this.addLocation.includes(id)) {
        if (!this.locationAddIds.includes(id)) {
            this.locationAddIds.push(id);
        }
        this.locationRemoveIds = this.locationRemoveIds.filter(item => item !== id);
    } else {
        if (!this.locationRemoveIds.includes(id)) {
            this.locationRemoveIds.push(id);
        }
        this.locationAddIds = this.locationAddIds.filter(item => item !== id);
    }
},

    addLocationFun() {
      this.addnewLocationloading = true;
      this.axios
        .post("/v2/financialclose/location/add", { data: [{ "name": this.locationdata.name, "description": this.locationdata.description, "country": this.locationdata.country, "type":this.locationdata.type }] })
        .then((ele) => {
          if (ele.data.status === "success") {
            this.addnewLocation = false;
            this.addnewLocationloading = false;
            this.$store.commit("sbSuccess", "location added successfully");
            this.getData();
          } else {
            if (ele.data.data.length > 0) {
              if (ele.data.data[0].index0)
                this.locationdataerror = ele.data.data[0].index0;
            } else throw new Error(ele.data.message);
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          this.addnewLocationloading = false;
          console.log(err);
        })
        .finally(() => {
          this.addnewLocationloading = false;
        });
    },
  getLocationNamesOnly(locationWithUserInfo) {
  if (!Array.isArray(locationWithUserInfo)) return [];
  // If any item does NOT have location_id, return []
  if (!locationWithUserInfo.every(loc => loc.location_id)) return [];
  const locationMap = new Map(this.location_details.map(loc => [loc._id, loc.name]));
  return locationWithUserInfo.map(loc => locationMap.get(loc.location_id) || "");
},

    mapLocationNames(locationWithUserInfo) {
    const locationMap = new Map(this.location_details.map(loc => [loc._id, loc.name]));
    return locationWithUserInfo.map(loc => ({
        ...loc,
        location_name: locationMap.get(loc.location_id) || "Unknown" // Handle missing names
    }));
},
    locationfilter(item = []) { 
      return item.map(header => header.name);
    },
    deleteLocation(id) {
      this.locationUserList = this.locationUserList.filter((item) => item.location_id !== id)
    },
    nextStage() {
      if (!this.validateCurentStage(this.bulkActionStage)) return;
      this.searchlocation = '';
      this.searchusername = '';
      this.bulkActionStage++;
      // Stage 4 is threshold enforcement — only relevant for Account Reconciliation tasks.
      // Skip it entirely and submit immediately if no AR tasks are selected.
      if (this.bulkActionStage === 4 && !this.bulkSelectionHasReconTasks) {
        this.submitChanges();
      }
    },
    validateCurentStage(stage = 2){
      const activeUserIds = new Set(this.userDetails.activeUserIds);
      let targetUsers = [];
      let errorType = "";

      if (stage === 2) {
        targetUsers = this.addPrepares;
        errorType = MESSAGES.INACTIVE_PREPARER_ERROR;
      } else if (stage === 3) {
        targetUsers = this.addApprover;
        errorType = MESSAGES.INACTIVE_APPROVER_ERROR;
      }

      if (!targetUsers?.length) return true;

      const inactiveNames = targetUsers
        .filter(userId => !activeUserIds.has(userId))
        .map(id => {
          const user = this.formdata?.users?.find(user => user?._id === id);
          return user?.name || id;
        })
        .filter(Boolean)
        .join(', ');

      if (inactiveNames) {
        this.$store.commit("sbError", `${errorType}: ${inactiveNames}`);
        return false;
      }
      return true;
    },
    submitChanges() {
      if(!this.validateCurentStage(this.bulkActionStage)) return;
      this.bulklocationChange(this.addLocation, this.addApprover, this.addPrepares, this.selectItem, this.bulkManageSkipValidation);
      this.bulkActionStage = 0;

    },
    filterPart(item) {
      this.tableFilterHeader = item;
      this.formatedData = this.$nova.filterByDynamicCriteria(
        this.formatedDataCopy,
        this.tableFilterHeader
      );
    },
      getRefresh(){
        this.refreshData();
      },
      async readColumns(){
        if (this.formateData.length === 0) {
      const response = await this.axios.post('/v2/financialclose/masters/checklist/readColumn/',{query:{cycle_type:this.cycleType.toUpperCase(), deleted: false}});
      if (response?.data?.status === 'success' && Array.isArray(response.data.data) && response?.data?.data.length > 0) {
        // Process the response and update customColumns
        let customColumnMapping = {};
        response.data.data.forEach(column => {
          let defaultValue;
          if (column.dataType === 'number') {
            defaultValue = 0; // Default value for numbers
          } else if (column.dataType === 'date') {
            defaultValue = new Date(); // Default value for dates
          } else {
            defaultValue = ''; // Default value for strings or other types
          }
          customColumnMapping = {
            ...customColumnMapping,
            [column.columnName]: defaultValue // Add new entries dynamically with default values
          };
        });
        this.customColumns = getCustomColumns(customColumnMapping)
        // Preserve saved visibility from existing headers if available
        const customHeaders = this.customColumns.map(header => {
          const columnName = header.columnName;
          // Check if this custom column already exists in headers (from saved layout)
          const existingHeader = this.headers.find(
            h => h.value === columnName || h.value_en === `custom_${columnName}`
          );
          // Preserve the saved visibility if it exists, otherwise default to true
          const savedVisibility = existingHeader?.visible !== undefined ? existingHeader.visible : true;
          
          return {
            value_en: `custom_${columnName}`,
            value: columnName,
            text: header.displayText,
            _id: response.data.data.find(col => col.columnName === columnName)?._id || null,
            visible: savedVisibility,
            custom: true,
            isEditing: false,
            filterable: false,
            sortable: false
          };
        });
      this.headers = this.headers.filter(h => !String(h.value_en).startsWith("custom_"));
      this.headers = [...this.headers, ...customHeaders];
      } 
    }
      },
    sortFun(array, key, order = 'ascending') {
    return array.slice().sort((a, b) => {
        const valA = a[key];
        const valB = b[key];
        const normalizedA = typeof valA === 'string' ? valA.toLowerCase() : valA;
        const normalizedB = typeof valB === 'string' ? valB.toLowerCase() : valB;

        if (normalizedA < normalizedB) return order === 'ascending' ? -1 : 1;
        if (normalizedA > normalizedB) return order === 'ascending' ? 1 : -1;
        return 0;
    });
},
      sortingOrder(key,order){
         this.formatedData = this.sortFun(this.formatedDataCopy,key,order)
      },
      async handleNewTask() {
  try {
    this.loading = true;
    this.resetTaskForm();
    // Make the API call to fetch data if needed
    if (this.formatedDataCopy.length === 0) {
      const response = await this.axios.post('/v2/financialclose/masters/checklist/readColumn/',{query:{cycle_type:this.cycleType.toUpperCase(), deleted: false}});
      if (response?.data?.status === 'success' && Array.isArray(response.data.data) && response?.data?.data.length > 0) {
        // Process the response and update customColumns
        let customColumnMapping = {};
        response.data.data.forEach(column => {
          let defaultValue;
          if (column.dataType === 'number') {
            defaultValue = 0; // Default value for numbers
          } else if (column.dataType === 'date') {
            defaultValue = new Date(); // Default value for dates
          } else {
            defaultValue = ''; // Default value for strings or other types
          }
          customColumnMapping = {
            ...customColumnMapping,
            [column.columnName]: defaultValue // Add new entries dynamically with default values
          };
        });
        this.customColumns = getCustomColumns(customColumnMapping)
      } 
    }

    // Reset data and open the dialog
    this.addeditdialog = true;
    this.addeditdata = {cycle_type: this.cycleType.toUpperCase()};
    
    this.addeditdataerror = {};
    this.locationUserList = [];
    this.customassertions = false;
  } catch (error) {
    console.error('Error handling new task:', error);
    this.$store.commit('sbError', error.message || 'Unknown error occurred');
  }finally {
    this.loading = false;
}
  }
},
  watch: {
    'addeditdata.task_type'(newVal) {
      // If component emitted full object (rare after TagInputs fix), coerce to its value
      if (newVal && typeof newVal === 'object') {
        const coerced = newVal.value || newVal.name || '';
        this.$set(this.addeditdata, 'task_type', coerced);
        return; // watcher will re-run with string
      }
      if (newVal === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
        this.addeditdata.glcode = []; // Clear selected GLs when switching back to Normal Task
      }
      if (newVal === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION) {
        // Clear free-text category/subcategory values that may not exist in COA
        if (this.addeditdata.category && !this.coaCategoryAcc.includes(this.addeditdata.category)) {
          this.addeditdata.category = '';
        }
        if (this.addeditdata.subcategory && !this.coaSubcategoryAcc.includes(this.addeditdata.subcategory)) {
          this.addeditdata.subcategory = '';
        }
      }
    },
    async 'addeditdata.cycle_type'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // Re-fetch categories for the selected cycle type
        await this.fetchAndMergeMasterCategories(newVal);
        // Clear category/subcategory if they don't exist in the new lists
        if (this.addeditdata.category && !this.categoryAcc.includes(this.addeditdata.category)) {
          this.addeditdata.category = '';
        }
        if (this.addeditdata.subcategory && !this.subcategoryAcc.includes(this.addeditdata.subcategory)) {
          this.addeditdata.subcategory = '';
        }
      }
    },
    cycleType(newVal) {
    if (newVal) {
      this.getData(newVal);
    }
  },
    selectItem: {
      handler() {
        if (!this.selectItem.length) {
          this.addLocation = [];
          this.addPrepares = [];
          this.addApprovers = [];
          return;
        }
        const locationIds = new Set();
        const preparerIds = new Set();
        const approverIds = new Set();

        this.selectItem.forEach((item) => {
          item.locationlist.forEach((loc) => {
            locationIds.add(loc.location_id);
            loc.preparer.forEach((preparerId) => preparerIds.add(preparerId));
            loc.approver.forEach((approverId) => approverIds.add(approverId));
          });
        });

        this.addLocation = Array.from(locationIds);
        this.addPrepares = Array.from(preparerIds);
        this.addApprover = Array.from(approverIds);
        this.copyaddLocation = Array.from(locationIds);

      },
      deep: true, // Watches for changes in nested objects
      immediate: true, // Runs initially
    },
    "addeditdata.assertions": function () {
      if (this.addeditdata.assertions && this.addeditdata.assertions.indexOf("Others") !== -1) {
        this.customassertions = true;
      }
      else {
        this.customassertions = false;
      }
    },
    "addeditdata.tags": function (newVal) {
      if (!Array.isArray(newVal)) return;
      const normalizedTags = this.normalizeAndDedupeTags(newVal);
      if (!this.areTagArraysEqual(normalizedTags, newVal)) {
        this.$set(this.addeditdata, 'tags', normalizedTags);
      }
      this.Alltags = this.normalizeAndDedupeTags([...(this.Alltags || []), ...normalizedTags]);
    },
    "formatedData": function () {
      this.storeTotal = (this.formatedData || []).length
    },
    locationUserList: function () {
      this.possibleGlCodes = [];
      for (var location of this.locationUserList) {
        const glCodes = this.locationBasedGl[location.location_id]?.map(item => item.glcode);
        if (glCodes) {
          this.possibleGlCodes.push(...glCodes);
        }
      }
      this.possibleGlCodes = Array.from(new Set(this.possibleGlCodes));
    },
    page: function (newVal) {
      this.pageInput = newVal;
    },
    showdatawitherrorEditBulk(newVal) {
      if (newVal) {
        this.errorsonlyEditBulk = this.dataerroreditBulk.filter(
          (item) => Object.keys(item).length > 0
        );
      } else {
        this.errorsonlyEditBulk = this.dataerroreditBulk;
      }
    },
  },
};
</script>

<style scoped>

.search-width {
  width: 3vh;
}

.location {
  color: #6B67CE;
  background-color: #F4F4FB;
  border: 1px solid #EBEBF7;
  border-radius: 4px;
  padding: 2px 5px !important;
}


.overDuedate {
  padding: 5px 10px;
  opacity: 0px;
  border-radius: 10px;
  border: 1px solid #FBEAEA;
  background: #FDF4F4;
  color: #E85B61
}

.dueDate {
  padding: 5px 8px;
  opacity: 0px;
  border-radius: 24px;
  border: 1px solid #EBEBF7;
  background: #F4F4FB;
  color: #6B67CE
}

.thead-color {
  background-color: var(--color-bg-light) !important;
}


.light-purple-background {
  background: #F4F4FB;

}

.description-fixed {
  position: absolute;
  background: white;
  width: 100%;
  z-index: 1;
  margin-top: -1.6vh;
  margin-left: -1vh;
}

.inactive-user-label {
  font-size: 0.75rem;
  color: #ff5252 !important; /* Red color for inactive label */
  font-weight: bold;
}

.flex-direction-column{
  flex-direction: column;
}

.max-height-40{
 max-height:40vh;
 overflow:auto;
}

.max-height-30{
  max-height:30vh;
  overflow:auto;
}

@media (max-width: 900px) {
  .max-height-40 {
    max-height: 60vw;
  }
}

@media (max-width: 600px) {
  .max-height-40 {
    max-height: 80vw;
  }
}
.action-icons{
  border-radius: var(--space-xs);
  background: var(--text-icon-combo);
  cursor: pointer;
  width: max-content;
}
</style>
